export default {
  personalities: [
    // groupNumber, term, most, least
    // 1
    {groupNumber: 1, term: 'Complacente', most: 'C', least: 'C'}, // Compliant (Flexível)
    {groupNumber: 1, term: 'Exigente', most: 'D', least: 'D'}, // Demanding (Exigente)
    {groupNumber: 1, term: 'Cativante', most: 'I', least: 'I'}, // Captivating (Cativante)
    {groupNumber: 1, term: 'Realizado', most: 'S', least: 'S'}, // Contented (Contentado)
    // 2
    {groupNumber: 2, term: 'Diplomático', most: 'C', least: 'C'}, // Diplomatic (Mediador)
    {groupNumber: 2, term: 'Ousado', most: 'D', least: 'D'}, // Daring (Ousado)
    {groupNumber: 2, term: 'Entusiasmado', most: 'I', least: 'I'}, // Enthuastic  (Entusiasmado)
    {groupNumber: 2, term: 'Satisfeito', most: 'S', least: 'S'}, // Satisfied (Satisfeito)
    // 3
    {groupNumber: 3, term: 'Flexível', most: '#', least: 'S'}, // Responsive (Dinâmico)
    {groupNumber: 3, term: 'Consciencioso', most: 'C', least: 'C'}, // Conscientious (Consciente)
    {groupNumber: 3, term: 'Dominante', most: 'D', least: 'D'}, // Dominant (Dominante)
    {groupNumber: 3, term: 'Expressivo', most: 'I', least: 'I'}, // Expressive (Expressivo)
    // 4
    {groupNumber: 4, term: 'Difícil de agradar', most: 'C', least: 'C'}, // Fussy (Difícil de Agradar)
    {groupNumber: 4, term: 'Firme', most: 'D', least: 'D'}, // Firm (Firme)
    {groupNumber: 4, term: 'Brincalhão', most: 'I', least: 'I'}, // Playful (Brincalhão)
    {groupNumber: 4, term: 'Obediente', most: 'S', least: 'S'}, // Obedient (Obediente)
    // 5
    {groupNumber: 5, term: 'Respeitoso', most: 'C', least: 'C'}, // Respectful (Respeitoso)
    {groupNumber: 5, term: 'Inovador', most: 'D', least: 'D'}, // Pioneering (Inovador)
    {groupNumber: 5, term: 'Otimista', most: 'I', least: 'I'}, // Optimistic (Otimista)
    {groupNumber: 5, term: 'Colaborativo', most: 'S', least: 'S'}, // Helpful (Colaborativo)
    // 6
    {groupNumber: 6, term: 'Comedido', most: 'C', least: 'C'}, // Private (Retraído)
    {groupNumber: 6, term: 'Competitivo', most: 'D', least: 'D'}, // Competitive (Competitivo)
    {groupNumber: 6, term: 'Contente', most: 'I', least: 'I'}, // Joyful (Divertido)
    {groupNumber: 6, term: 'Atencioso', most: 'S', least: 'S'}, // Considerate (Atencioso)
    // 7
    {groupNumber: 7, term: 'Sistemático', most: 'C', least: 'C'}, // Systematic (Sistemático)
    {groupNumber: 7, term: 'Questionador', most: 'D', least: 'D'}, // Argumentative (Questionador)
    {groupNumber: 7, term: 'Despreocupado', most: 'I', least: 'I'}, // Light-hearted (Despreocupado)
    {groupNumber: 7, term: 'Cooperativo', most: 'S', least: 'S'}, // Cooperative (Cooperativo)
    // 8
    {groupNumber: 8, term: 'Reservado', most: 'C', least: 'C'}, // Reserved (Reservado)
    {groupNumber: 8, term: 'Obstinado', most: 'D', least: 'D'}, // Strong-willed (Motivado)
    {groupNumber: 8, term: 'Alegre', most: 'I', least: 'I'}, // Cheerful (Animado)
    {groupNumber: 8, term: 'Prestativo', most: 'S', least: 'S'}, // Obliging (Prestativo)
    // 9
    {groupNumber: 9, term: 'Calmo', most: '#', least: 'S'}, // Calm (Calmo)
    {groupNumber: 9, term: 'Objetivo', most: 'C', least: 'C'}, // Accurate (Exato, Certeiro)
    {groupNumber: 9, term: 'Sincero', most: 'D', least: 'D'}, // Outspoken (Sincero)
    {groupNumber: 9, term: 'Amigável', most: 'I', least: '#'}, // Friendly (Amigável)
    // 10
    {groupNumber: 10, term: 'Receoso', most: '#', least: 'C'}, // Fearful (Receoso)
    {groupNumber: 10, term: 'Agressivo', most: 'D', least: 'D'}, // Aggressive (Agressivo)
    {groupNumber: 10, term: 'Extrovertido', most: 'I', least: 'I'}, // Extroverted (Extrovertido)
    {groupNumber: 10, term: 'Amável', most: 'S', least: 'S'}, // Amiable (Amável)
    // 11
    {groupNumber: 11, term: 'Imparcial', most: '#', least: 'C'}, // Impartial (Imparcial)
    {groupNumber: 11, term: 'Assertivo', most: 'D', least: 'D'}, // Assertive (Assertivo)
    {groupNumber: 11, term: 'Confiante', most: 'I', least: 'I'}, // Confident (Confiante)
    {groupNumber: 11, term: 'Simpático', most: 'S', least: 'S'}, // Sympathetic (Solidário)
    // 12
    {groupNumber: 12, term: 'Cuidadoso', most: 'C', least: 'C'}, // Careful (Cuidadoso)
    {groupNumber: 12, term: 'Inquieto', most: 'D', least: 'D'}, // Restless (Inquieto)
    {groupNumber: 12, term: 'Atraente', most: 'I', least: 'I'}, // Appealing (Atraente)
    {groupNumber: 12, term: 'Bem-educado', most: 'S', least: 'S'}, // Neighborly (Educado)
    // 13
    {groupNumber: 13, term: 'Afável', most: 'C', least: 'C'}, // Soft spoken (Moderado)
    {groupNumber: 13, term: 'Autoconfiante', most: 'D', least: 'D'}, // Self-reliant (Autoconfiante)
    {groupNumber: 13, term: 'Sociável', most: 'I', least: 'I'}, // Sociable (Sociável)
    {groupNumber: 13, term: 'Paciente', most: 'S', least: 'S'}, // Patient (Paciente)
    // 14
    {groupNumber: 14, term: 'Tímido', most: '#', least: 'C'}, // Timid (Tímido)
    {groupNumber: 14, term: 'Valente', most: 'D', least: 'D'}, // Brave (Valente)
    {groupNumber: 14, term: 'Inspirador', most: 'I', least: 'I'}, // Inspiring (Motivador)
    {groupNumber: 14, term: 'Submisso', most: 'S', least: 'S'}, // Submissive (Subordinado)
    // 15
    {groupNumber: 15, term: 'Perspicaz', most: 'C', least: 'C'}, // Insightful (Astuto)
    {groupNumber: 15, term: 'Aventureiro', most: 'D', least: 'D'}, // Adventurous (Aventureiro)
    {groupNumber: 15, term: 'Descontraído', most: 'I', least: 'I'}, // Out-going (Descontraído)
    {groupNumber: 15, term: 'Moderado', most: 'S', least: 'S'}, // Moderate (Moderado)
    // 16
    {groupNumber: 16, term: 'Humilde', most: '#', least: 'C'}, // Humble (Humilde)
    {groupNumber: 16, term: 'Original', most: '#', least: 'D'}, // Original (Original)
    {groupNumber: 16, term: 'Persuasivo', most: 'I', least: '#'}, // Persuasive (Persuasivo)
    {groupNumber: 16, term: 'Gentil', most: 'S', least: 'S'}, // Gentle (Gentil)
    // 17
    {groupNumber: 17, term: 'Preciso', most: 'C', least: 'C'}, // Precise (Preciso)
    {groupNumber: 17, term: 'Direto', most: 'D', least: 'D'}, // Direct (Direto)
    {groupNumber: 17, term: 'Jovial', most: 'I', least: 'I'}, // Jovial (Alegre)
    {groupNumber: 17, term: 'Equilibrado', most: 'S', least: 'S'}, // Even-tempered (Equilibrado)
    // 18
    {groupNumber: 18, term: 'Controlado', most: 'C', least: 'C'}, // Controlled
    {groupNumber: 18, term: 'Decisivo', most: 'D', least: 'D'}, // Decisive
    {groupNumber: 18, term: 'Comunicativo', most: 'I', least: 'I'}, // Talkative
    {groupNumber: 18, term: 'Convencional', most: 'S', least: 'S'}, // Conventional
    // 19
    {groupNumber: 19, term: 'Perceptivo', most: 'C', least: 'C'}, // Perceptive (Perceptivo)
    {groupNumber: 19, term: 'Independente', most: 'D', least: 'D'}, // Independent (Independente)
    {groupNumber: 19, term: 'Estimulante', most: 'I', least: 'I'}, // Stimulating (Entusiasmante)
    {groupNumber: 19, term: 'Educado', most: 'S', least: 'S'}, // Kind (Educado)
    // 20
    {groupNumber: 20, term: 'Cortês', most: 'C', least: 'C'}, // Tactful (Mediador)
    {groupNumber: 20, term: 'Insistente', most: 'D', least: 'D'}, // Insistent (Insistente)
    {groupNumber: 20, term: 'Carismático', most: 'I', least: 'I'}, // Magnetic (Carismático)
    {groupNumber: 20, term: 'Agradável', most: 'S', least: 'S'}, // Agreeable (Agradável)
    // 21
    {groupNumber: 21, term: 'Disciplinado', most: 'C', least: 'C'}, // Well-desciplined (Disciplinado)
    {groupNumber: 21, term: 'Persistente', most: 'D', least: 'D'}, // Persistent (Persistente)
    {groupNumber: 21, term: 'Animado', most: 'I', least: 'I'}, // Animated (Enérgico)
    {groupNumber: 21, term: 'Generoso', most: 'S', least: 'S'}, // Generous (Generoso)
    // 22
    {groupNumber: 22, term: 'Minucioso', most: 'C', least: 'C'}, // Thorough (Minucioso)
    {groupNumber: 22, term: 'Ansioso', most: 'D', least: '#'}, // Eager (Ansioso)
    {groupNumber: 22, term: 'Alto astral', most: 'I', least: 'I'}, // High-spirited (Alto Astral)
    {groupNumber: 22, term: 'Solícito', most: 'S', least: 'S'}, // Wiling (Solícito)
    // 23
    {groupNumber: 23, term: 'Introvertido', most: 'C', least: 'C'}, // Introverted (Introvertido)
    {groupNumber: 23, term: 'Contundente', most: 'D', least: 'D'}, // Forceful (Contundente)
    {groupNumber: 23, term: 'Impulsivo', most: 'I', least: 'I'}, // Impulsive (Impulsivo)
    {groupNumber: 23, term: 'Maleável', most: 'S', least: 'S'}, // Easy-going (Descontraído)
    // 24
    {groupNumber: 24, term: 'Observador', most: 'C', least: '#'}, // Observant (Observador)
    {groupNumber: 24, term: 'Impaciente', most: 'D', least: 'D'}, // Inpatient (Impaciente)
    {groupNumber: 24, term: 'Ponderado', most: 'I', least: 'I'}, // Poised (Preparado)
    {groupNumber: 24, term: 'Modesto', most: 'S', least: 'S'}, // Modest (Modesto)
    // 25
    {groupNumber: 25, term: 'Refinado', most: 'C', least: 'C'}, // Refined (Nobre)
    {groupNumber: 25, term: 'Vigoroso', most: 'D', least: 'D'}, // Vigorous (Vigoroso)
    {groupNumber: 25, term: 'Popular', most: 'I', least: 'I'}, // Good mixer (Popular)
    {groupNumber: 25, term: 'Tolerante', most: 'S', least: 'S'}, // Lenient (Tolerante)
    // 26
    {groupNumber: 26, term: 'Introspectivo', most: 'C', least: '#'}, // Introspective (Reflexivo)
    {groupNumber: 26, term: 'Teimoso', most: 'D', least: 'D'}, // Stubborn (Teimoso)
    {groupNumber: 26, term: 'Encantador', most: 'I', least: 'I'}, // Attractive (Atraente)
    {groupNumber: 26, term: 'Previsível', most: 'S', least: 'S'}, // Predictable (Previsível)
    // 27
    {groupNumber: 27, term: 'Lógico', most: 'C', least: 'C'}, // Logical (Lógico)
    {groupNumber: 27, term: 'Corajoso', most: 'D', least: 'D'}, // Bold (Corajoso)
    {groupNumber: 27, term: 'Charmoso', most: 'I', least: 'I'}, // Charming (Sedutor)
    {groupNumber: 27, term: 'Leal', most: 'S', least: 'S'}, // Loyal (Leal)
    // 28
    {groupNumber: 28, term: 'Cauteloso', most: 'C', least: 'C'}, // Cautious (Cauteloso)
    {groupNumber: 28, term: 'Determinado', most: 'D', least: 'D'}, // Determined (Determinado)
    {groupNumber: 28, term: 'Convincente', most: 'I', least: 'I'}, // Convicing (Convincente)
    {groupNumber: 28, term: 'Bondoso', most: 'S', least: '#'} // Good Natured (Bondoso)
  ],
  results: [
    // https://internalchange.com/wp-content/uploads/DiSC-Classic-3-Graphs-1024x603.png
    // graph, dimension, intensity, segment, value
    [1, 'D', 28, 7, [27]],
    [1, 'D', 27, 7, [26, 25, 24, 23, 22, 21, 20, 19, 18, 17, 16, 15, 14, 13]],
    [1, 'D', 26, 7, [12]],
    [1, 'D', 25, 7, [11]],
    [1, 'D', 24, 6, [10]],
    [1, 'D', 23, 6, [9]],
    [1, 'D', 22, 6, [8]],
    [1, 'D', 21, 6, []],
    [1, 'D', 20, 5, [7]],
    [1, 'D', 19, 5, [6]],
    [1, 'D', 18, 5, []],
    [1, 'D', 17, 5, []],
    [1, 'D', 16, 4, [5]],
    [1, 'D', 15, 4, []],
    [1, 'D', 14, 4, [4]],
    [1, 'D', 13, 4, []],
    [1, 'D', 12, 3, [3]],
    [1, 'D', 11, 3, []],
    [1, 'D', 10, 3, []],
    [1, 'D', 9, 3, [2]],
    [1, 'D', 8, 2, []],
    [1, 'D', 7, 2, []],
    [1, 'D', 6, 2, [1]],
    [1, 'D', 5, 2, []],
    [1, 'D', 4, 1, []],
    [1, 'D', 3, 1, [0]],
    [1, 'D', 2, 1, []],
    [1, 'D', 1, 1, []],
    [1, 'I', 28, 7, [28]],
    [1, 'I', 27, 7, [27, 26, 25, 24, 23, 22, 21, 20, 19, 18, 17, 16, 15, 14, 13]],
    [1, 'I', 26, 7, [12]],
    [1, 'I', 25, 7, [11]],
    [1, 'I', 24, 6, []],
    [1, 'I', 23, 6, [10]],
    [1, 'I', 22, 6, [9]],
    [1, 'I', 21, 6, []],
    [1, 'I', 20, 5, [8]],
    [1, 'I', 19, 5, []],
    [1, 'I', 18, 5, []],
    [1, 'I', 17, 5, []],
    [1, 'I', 16, 4, [7]],
    [1, 'I', 15, 4, []],
    [1, 'I', 14, 4, [6]],
    [1, 'I', 13, 4, []],
    [1, 'I', 12, 3, [5]],
    [1, 'I', 11, 3, []],
    [1, 'I', 10, 3, []],
    [1, 'I', 9, 3, [4]],
    [1, 'I', 8, 2, []],
    [1, 'I', 7, 2, []],
    [1, 'I', 6, 2, [3]],
    [1, 'I', 5, 2, []],
    [1, 'I', 4, 1, [2]],
    [1, 'I', 3, 1, []],
    [1, 'I', 2, 1, [1]],
    [1, 'I', 1, 1, [0]],
    [1, 'S', 28, 7, [26]],
    [1, 'S', 27, 7, [25, 24, 23, 22, 21, 20, 19, 18, 17, 16, 15]],
    [1, 'S', 26, 7, [14]],
    [1, 'S', 25, 7, [13]],
    [1, 'S', 24, 6, []],
    [1, 'S', 23, 6, [12]],
    [1, 'S', 22, 6, []],
    [1, 'S', 21, 6, [11]],
    [1, 'S', 20, 5, []],
    [1, 'S', 19, 5, [10]],
    [1, 'S', 18, 5, []],
    [1, 'S', 17, 5, [9]],
    [1, 'S', 16, 4, []],
    [1, 'S', 15, 4, [8]],
    [1, 'S', 14, 4, []],
    [1, 'S', 13, 4, [7]],
    [1, 'S', 12, 3, []],
    [1, 'S', 11, 3, [6]],
    [1, 'S', 10, 3, [5]],
    [1, 'S', 9, 3, []],
    [1, 'S', 8, 2, []],
    [1, 'S', 7, 2, []],
    [1, 'S', 6, 2, [4]],
    [1, 'S', 5, 2, []],
    [1, 'S', 4, 1, [3]],
    [1, 'S', 3, 1, [2]],
    [1, 'S', 2, 1, [1]],
    [1, 'S', 1, 1, [0]],
    [1, 'C', 28, 7, [24, 23, 22, 21, 20, 19, 18, 17, 16, 15, 14, 13]],
    [1, 'C', 27, 7, [12]],
    [1, 'C', 26, 7, [11]],
    [1, 'C', 25, 7, []],
    [1, 'C', 24, 6, [10]],
    [1, 'C', 23, 6, [9]],
    [1, 'C', 22, 6, []],
    [1, 'C', 21, 6, [8]],
    [1, 'C', 20, 5, []],
    [1, 'C', 19, 5, [7]],
    [1, 'C', 18, 5, []],
    [1, 'C', 17, 5, []],
    [1, 'C', 16, 4, [6]],
    [1, 'C', 15, 4, []],
    [1, 'C', 14, 4, []],
    [1, 'C', 13, 4, [5]],
    [1, 'C', 12, 3, []],
    [1, 'C', 11, 3, []],
    [1, 'C', 10, 3, [4]],
    [1, 'C', 9, 3, []],
    [1, 'C', 8, 2, []],
    [1, 'C', 7, 2, [3]],
    [1, 'C', 6, 2, []],
    [1, 'C', 5, 2, []],
    [1, 'C', 4, 1, [2]],
    [1, 'C', 3, 1, []],
    [1, 'C', 2, 1, [1]],
    [1, 'C', 1, 1, [0]],
    [2, 'D', 28, 7, [0]],
    [2, 'D', 27, 7, [1]],
    [2, 'D', 26, 7, [2, 3]],
    [2, 'D', 25, 7, [4]],
    [2, 'D', 24, 6, [5]],
    [2, 'D', 23, 6, []],
    [2, 'D', 22, 6, [6]],
    [2, 'D', 21, 6, [7]],
    [2, 'D', 20, 5, []],
    [2, 'D', 19, 5, [8]],
    [2, 'D', 18, 5, [9]],
    [2, 'D', 17, 5, []],
    [2, 'D', 16, 4, []],
    [2, 'D', 15, 4, []],
    [2, 'D', 14, 4, [10]],
    [2, 'D', 13, 4, []],
    [2, 'D', 12, 3, [11]],
    [2, 'D', 11, 3, [12]],
    [2, 'D', 10, 3, []],
    [2, 'D', 9, 3, [13]],
    [2, 'D', 8, 2, []],
    [2, 'D', 7, 2, [14]],
    [2, 'D', 6, 2, []],
    [2, 'D', 5, 2, [15]],
    [2, 'D', 4, 1, [16]],
    [2, 'D', 3, 1, [17]],
    [2, 'D', 2, 1, [18, 19, 20, 21, 22, 23, 24, 25, 26]],
    [2, 'D', 1, 1, [27]],
    [2, 'I', 28, 7, [0]],
    [2, 'I', 27, 7, []],
    [2, 'I', 26, 7, [1]],
    [2, 'I', 25, 7, [2]],
    [2, 'I', 24, 6, []],
    [2, 'I', 23, 6, [3]],
    [2, 'I', 22, 6, []],
    [2, 'I', 21, 6, []],
    [2, 'I', 20, 5, [4]],
    [2, 'I', 19, 5, []],
    [2, 'I', 18, 5, []],
    [2, 'I', 17, 5, []],
    [2, 'I', 16, 4, [5]],
    [2, 'I', 15, 4, []],
    [2, 'I', 14, 4, []],
    [2, 'I', 13, 4, []],
    [2, 'I', 12, 3, [6]],
    [2, 'I', 11, 3, []],
    [2, 'I', 10, 3, [7]],
    [2, 'I', 9, 3, []],
    [2, 'I', 8, 2, []],
    [2, 'I', 7, 2, [8]],
    [2, 'I', 6, 2, []],
    [2, 'I', 5, 2, []],
    [2, 'I', 4, 1, [9]],
    [2, 'I', 3, 1, [10]],
    [2, 'I', 2, 1, [11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25]],
    [2, 'I', 1, 1, [26]],
    [2, 'S', 28, 7, [0]],
    [2, 'S', 27, 7, []],
    [2, 'S', 26, 7, [1]],
    [2, 'S', 25, 7, []],
    [2, 'S', 24, 6, []],
    [2, 'S', 23, 6, []],
    [2, 'S', 22, 6, [2]],
    [2, 'S', 21, 6, []],
    [2, 'S', 20, 5, []],
    [2, 'S', 19, 5, []],
    [2, 'S', 18, 5, [3]],
    [2, 'S', 17, 5, []],
    [2, 'S', 16, 4, []],
    [2, 'S', 15, 4, [4]],
    [2, 'S', 14, 4, []],
    [2, 'S', 13, 4, []],
    [2, 'S', 12, 3, [5]],
    [2, 'S', 11, 3, []],
    [2, 'S', 10, 3, []],
    [2, 'S', 9, 3, [6]],
    [2, 'S', 8, 2, []],
    [2, 'S', 7, 2, [7]],
    [2, 'S', 6, 2, []],
    [2, 'S', 5, 2, [8]],
    [2, 'S', 4, 1, [9]],
    [2, 'S', 3, 1, [10]],
    [2, 'S', 2, 1, [11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26]],
    [2, 'S', 1, 1, [27]],
    [2, 'C', 28, 7, [0]],
    [2, 'C', 27, 7, [1]],
    [2, 'C', 26, 7, [2]],
    [2, 'C', 25, 7, [3]],
    [2, 'C', 24, 6, [4]],
    [2, 'C', 23, 6, []],
    [2, 'C', 22, 6, [5]],
    [2, 'C', 21, 6, []],
    [2, 'C', 20, 5, [6]],
    [2, 'C', 19, 5, []],
    [2, 'C', 18, 5, []],
    [2, 'C', 17, 5, []],
    [2, 'C', 16, 4, [7]],
    [2, 'C', 15, 4, []],
    [2, 'C', 14, 4, [8]],
    [2, 'C', 13, 4, []],
    [2, 'C', 12, 3, []],
    [2, 'C', 11, 3, [9]],
    [2, 'C', 10, 3, []],
    [2, 'C', 9, 3, []],
    [2, 'C', 8, 2, [10]],
    [2, 'C', 7, 2, []],
    [2, 'C', 6, 2, [11]],
    [2, 'C', 5, 2, []],
    [2, 'C', 4, 1, [12]],
    [2, 'C', 3, 1, [13]],
    [2, 'C', 2, 1, [14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25]],
    [2, 'C', 1, 1, [26]],
    [3, 'D', 28, 7, [27]],
    [3, 'D', 27, 7, [26, 25, 24, 23, 22, 21, 20, 19, 18, 17, 16, 15, 14, 13, 12, 11, 10]],
    [3, 'D', 26, 7, [9, 8, 7]],
    [3, 'D', 25, 7, [6]],
    [3, 'D', 24, 6, [5, 4]],
    [3, 'D', 23, 6, [3, 2]],
    [3, 'D', 22, 6, [1]],
    [3, 'D', 21, 6, [0]],
    [3, 'D', 20, 5, [-1]],
    [3, 'D', 19, 5, [-2, -3]],
    [3, 'D', 18, 5, [-4]],
    [3, 'D', 17, 5, []],
    [3, 'D', 16, 4, [-5]],
    [3, 'D', 15, 4, [-6]],
    [3, 'D', 14, 4, [-7]],
    [3, 'D', 13, 4, []],
    [3, 'D', 12, 3, [-8]],
    [3, 'D', 11, 3, [-9]],
    [3, 'D', 10, 3, [-10]],
    [3, 'D', 9, 3, [-11]],
    [3, 'D', 8, 2, [-12]],
    [3, 'D', 7, 2, [-13]],
    [3, 'D', 6, 2, [-14]],
    [3, 'D', 5, 2, []],
    [3, 'D', 4, 1, [-15]],
    [3, 'D', 3, 1, [-16]],
    [3, 'D', 2, 1, [-17, -18, -19, -20, -21, -22, -23, -24, -25, -26]],
    [3, 'D', 1, 1, [-27]],
    [3, 'I', 28, 7, [28]],
    [3, 'I', 27, 7, [27, 26, 25, 24, 23, 22, 21, 20, 19, 18, 17, 16, 15, 14, 13, 12, 11, 10]],
    [3, 'I', 26, 7, [9]],
    [3, 'I', 25, 7, [8]],
    [3, 'I', 24, 6, [7]],
    [3, 'I', 23, 6, []],
    [3, 'I', 22, 6, [6]],
    [3, 'I', 21, 6, []],
    [3, 'I', 20, 5, [5]],
    [3, 'I', 19, 5, [4]],
    [3, 'I', 18, 5, [3]],
    [3, 'I', 17, 5, []],
    [3, 'I', 16, 4, []],
    [3, 'I', 15, 4, [2]],
    [3, 'I', 14, 4, [1]],
    [3, 'I', 13, 4, []],
    [3, 'I', 12, 3, [0]],
    [3, 'I', 11, 3, [-1]],
    [3, 'I', 10, 3, []],
    [3, 'I', 9, 3, [-2]],
    [3, 'I', 8, 2, [-3]],
    [3, 'I', 7, 2, [-4]],
    [3, 'I', 6, 2, [-5]],
    [3, 'I', 5, 2, []],
    [3, 'I', 4, 1, [-6, -7]],
    [3, 'I', 3, 1, [-8]],
    [3, 'I', 2, 1, [-9, -10, -11, -12, -13, -14, -15, 16, -17, -18, -19, -20, -21, -22, -23, -24, -25]],
    [3, 'I', 1, 1, [-26]],
    [3, 'S', 28, 7, [26, 25, 24, 23, 22, 21, 20, 19, 18, 17, 16, 15]],
    [3, 'S', 27, 7, [14]],
    [3, 'S', 26, 7, [13]],
    [3, 'S', 25, 7, [12]],
    [3, 'S', 24, 6, [11]],
    [3, 'S', 23, 6, [10]],
    [3, 'S', 22, 6, []],
    [3, 'S', 21, 6, [9]],
    [3, 'S', 20, 5, [8]],
    [3, 'S', 19, 5, [7]],
    [3, 'S', 18, 5, []],
    [3, 'S', 17, 5, [6]],
    [3, 'S', 16, 4, []],
    [3, 'S', 15, 4, [5]],
    [3, 'S', 14, 4, [4]],
    [3, 'S', 13, 4, [3]],
    [3, 'S', 12, 3, [2]],
    [3, 'S', 11, 3, [1]],
    [3, 'S', 10, 3, [0]],
    [3, 'S', 9, 3, []],
    [3, 'S', 8, 2, [-1]],
    [3, 'S', 7, 2, [-2]],
    [3, 'S', 6, 2, [-3]],
    [3, 'S', 5, 2, [-4]],
    [3, 'S', 4, 1, [-5, -6]],
    [3, 'S', 3, 1, [-7]],
    [3, 'S', 2, 1, [-8, -9, -10, -11, -12, -13, -14, -15, 16, -17, -18, -19, -20, -21, -22, -23, -24, -25, -26]],
    [3, 'S', 1, 1, [-27]],
    [3, 'C', 28, 7, [24, 23, 22, 21, 20, 19]],
    [3, 'C', 27, 7, [18]],
    [3, 'C', 26, 7, [17, 16, 15, 14, 13, 12, 11, 10, 9, 8, 7]],
    [3, 'C', 25, 7, [6]],
    [3, 'C', 24, 6, [5]],
    [3, 'C', 23, 6, [4]],
    [3, 'C', 22, 6, []],
    [3, 'C', 21, 6, [3]],
    [3, 'C', 20, 5, [2]],
    [3, 'C', 19, 5, [1]],
    [3, 'C', 18, 5, [0]],
    [3, 'C', 17, 5, []],
    [3, 'C', 16, 4, [-1]],
    [3, 'C', 15, 4, [-2]],
    [3, 'C', 14, 4, []],
    [3, 'C', 13, 4, []],
    [3, 'C', 12, 3, [-3]],
    [3, 'C', 11, 3, [-4]],
    [3, 'C', 10, 3, [-5]],
    [3, 'C', 9, 3, []],
    [3, 'C', 8, 2, [-6]],
    [3, 'C', 7, 2, [-7]],
    [3, 'C', 6, 2, []],
    [3, 'C', 5, 2, [-8]],
    [3, 'C', 4, 1, [-9, -10]],
    [3, 'C', 3, 1, [-11]],
    [3, 'C', 2, 1, [-12, -13, -14, -15, 16, -17, -18, -19, -20, -21, -22, -23, -24, -25]],
    [3, 'C', 1, 1, [-26]]
  ],
  categoryScore: {
    '1211': 'Retake self-assessment',
    '1212': 'Retake self-assessment',
    '1213': 'Retake self-assessment',
    '1214': 'Retake self-assessment',
    '1215': 'Objective Thinker',
    '1216': 'Objective Thinker',
    '1217': 'Objective Thinker',
    '1221': 'Retake self-assessment',
    '1222': 'Retake self-assessment',
    '1223': 'Retake self-assessment',
    '1224': 'Retake self-assessment',
    '1225': 'Objective Thinker',
    '1226': 'Objective Thinker',
    '1227': 'Objective Thinker',
    '1231': 'Retake self-assessment',
    '1232': 'Retake self-assessment',
    '1233': 'Retake self-assessment',
    '1234': 'Retake self-assessment',
    '1235': 'Objective Thinker',
    '1236': 'Objective Thinker',
    '1237': 'Objective Thinker',
    '1241': 'Retake self-assessment',
    '1242': 'Retake self-assessment',
    '1243': 'Retake self-assessment',
    '1244': 'Retake self-assessment',
    '1245': 'Objective Thinker',
    '1246': 'Objective Thinker',
    '1247': 'Objective Thinker',
    '1251': 'Specialist',
    '1252': 'Specialist',
    '1253': 'Specialist',
    '1254': 'Specialist',
    '1255': 'Perfectionist',
    '1256': 'Perfectionist',
    '1257': 'Perfectionist',
    '1261': 'Specialist',
    '1262': 'Specialist',
    '1263': 'Specialist',
    '1264': 'Specialist',
    '1265': 'Perfectionist',
    '1266': 'Perfectionist',
    '1267': 'Perfectionist',
    '1271': 'Specialist',
    '1272': 'Specialist',
    '1273': 'Specialist',
    '1274': 'Specialist',
    '1275': 'Perfectionist',
    '1276': 'Perfectionist',
    '1277': 'Perfectionist',
    '1311': 'Retake self-assessment',
    '1312': 'Retake self-assessment',
    '1313': 'Retake self-assessment',
    '1314': 'Retake self-assessment',
    '1315': 'Objective Thinker',
    '1316': 'Objective Thinker',
    '1317': 'Objective Thinker',
    '1321': 'Retake self-assessment',
    '1322': 'Retake self-assessment',
    '1323': 'Retake self-assessment',
    '1324': 'Retake self-assessment',
    '1325': 'Objective Thinker',
    '1326': 'Objective Thinker',
    '1327': 'Objective Thinker',
    '1331': 'Retake self-assessment',
    '1332': 'Retake self-assessment',
    '1333': 'Retake self-assessment',
    '1334': 'Retake self-assessment',
    '1335': 'Objective Thinker',
    '1336': 'Objective Thinker',
    '1337': 'Objective Thinker',
    '1341': 'Retake self-assessment',
    '1342': 'Retake self-assessment',
    '1343': 'Retake self-assessment',
    '1344': 'Retake self-assessment',
    '1345': 'Objective Thinker',
    '1346': 'Objective Thinker',
    '1347': 'Objective Thinker',
    '1351': 'Specialist',
    '1352': 'Specialist',
    '1353': 'Specialist',
    '1354': 'Specialist',
    '1355': 'Perfectionist',
    '1356': 'Perfectionist',
    '1357': 'Perfectionist',
    '1361': 'Specialist',
    '1362': 'Specialist',
    '1363': 'Specialist',
    '1364': 'Specialist',
    '1365': 'Perfectionist',
    '1366': 'Perfectionist',
    '1367': 'Perfectionist',
    '1371': 'Specialist',
    '1372': 'Specialist',
    '1373': 'Specialist',
    '1374': 'Specialist',
    '1375': 'Perfectionist',
    '1376': 'Perfectionist',
    '1377': 'Perfectionist',
    '1511': 'Promoter',
    '1512': 'Promoter',
    '1513': 'Promoter',
    '1514': 'Promoter',
    '1515': 'Appraiser',
    '1516': 'Appraiser',
    '1517': 'Appraiser',
    '1521': 'Promoter',
    '1522': 'Promoter',
    '1523': 'Promoter',
    '1524': 'Promoter',
    '1525': 'Appraiser',
    '1526': 'Appraiser',
    '1527': 'Appraiser',
    '1531': 'Promoter',
    '1532': 'Promoter',
    '1533': 'Promoter',
    '1534': 'Promoter',
    '1535': 'Appraiser',
    '1536': 'Appraiser',
    '1537': 'Appraiser',
    '1541': 'Promoter',
    '1542': 'Promoter',
    '1543': 'Promoter',
    '1544': 'Promoter',
    '1545': 'Practitioner',
    '1546': 'Practitioner',
    '1547': 'Practitioner',
    '1551': 'Counselor',
    '1552': 'Counselor',
    '1553': 'Counselor',
    '1554': 'Counselor',
    '1555': 'Practitioner',
    '1556': 'Practitioner',
    '1557': 'Practitioner',
    '1561': 'Agent',
    '1562': 'Agent',
    '1563': 'Agent',
    '1564': 'Agent',
    '1565': 'Practitioner',
    '1566': 'Practitioner',
    '1567': 'Practitioner',
    '1571': 'Agent',
    '1572': 'Agent',
    '1573': 'Agent',
    '1574': 'Agent',
    '1575': 'Practitioner',
    '1576': 'Practitioner',
    '1577': 'Practitioner',
    '1611': 'Promoter',
    '1612': 'Promoter',
    '1613': 'Promoter',
    '1614': 'Promoter',
    '1615': 'Appraiser',
    '1616': 'Appraiser',
    '1617': 'Appraiser',
    '1621': 'Promoter',
    '1622': 'Promoter',
    '1623': 'Promoter',
    '1624': 'Promoter',
    '1625': 'Appraiser',
    '1626': 'Appraiser',
    '1627': 'Appraiser',
    '1631': 'Promoter',
    '1632': 'Promoter',
    '1633': 'Promoter',
    '1634': 'Promoter',
    '1635': 'Appraiser',
    '1636': 'Appraiser',
    '1637': 'Appraiser',
    '1641': 'Promoter',
    '1642': 'Promoter',
    '1643': 'Promoter',
    '1644': 'Promoter',
    '1645': 'Practitioner',
    '1646': 'Practitioner',
    '1647': 'Practitioner',
    '1651': 'Counselor',
    '1652': 'Counselor',
    '1653': 'Counselor',
    '1654': 'Counselor',
    '1655': 'Practitioner',
    '1656': 'Practitioner',
    '1657': 'Practitioner',
    '1661': 'Counselor',
    '1662': 'Counselor',
    '1663': 'Counselor',
    '1664': 'Counselor',
    '1665': 'Practitioner',
    '1666': 'Practitioner',
    '1667': 'Practitioner',
    '1671': 'Agent',
    '1672': 'Agent',
    '1673': 'Agent',
    '1674': 'Agent',
    '1675': 'Practitioner',
    '1676': 'Practitioner',
    '1677': 'Practitioner',
    '2111': 'Retake self-assessment',
    '2112': 'Retake self-assessment',
    '2113': 'Retake self-assessment',
    '2114': 'Retake self-assessment',
    '2115': 'Objective Thinker',
    '2116': 'Objective Thinker',
    '2117': 'Objective Thinker',
    '2121': 'Retake self-assessment',
    '2122': 'Retake self-assessment',
    '2123': 'Retake self-assessment',
    '2124': 'Retake self-assessment',
    '2125': 'Objective Thinker',
    '2126': 'Objective Thinker',
    '2127': 'Objective Thinker',
    '2131': 'Retake self-assessment',
    '2132': 'Retake self-assessment',
    '2133': 'Retake self-assessment',
    '2134': 'Retake self-assessment',
    '2135': 'Objective Thinker',
    '2136': 'Objective Thinker',
    '2137': 'Objective Thinker',
    '2141': 'Retake self-assessment',
    '2142': 'Retake self-assessment',
    '2143': 'Retake self-assessment',
    '2144': 'Retake self-assessment',
    '2145': 'Objective Thinker',
    '2146': 'Objective Thinker',
    '2147': 'Objective Thinker',
    '2151': 'Specialist',
    '2152': 'Specialist',
    '2153': 'Specialist',
    '2154': 'Specialist',
    '2155': 'Perfectionist',
    '2156': 'Perfectionist',
    '2157': 'Perfectionist',
    '2161': 'Specialist',
    '2162': 'Specialist',
    '2163': 'Specialist',
    '2164': 'Specialist',
    '2165': 'Perfectionist',
    '2166': 'Perfectionist',
    '2167': 'Perfectionist',
    '2171': 'Specialist',
    '2172': 'Specialist',
    '2173': 'Specialist',
    '2174': 'Specialist',
    '2175': 'Perfectionist',
    '2176': 'Perfectionist',
    '2177': 'Perfectionist',
    '2211': 'Retake self-assessment',
    '2212': 'Retake self-assessment',
    '2213': 'Retake self-assessment',
    '2214': 'Retake self-assessment',
    '2215': 'Objective Thinker',
    '2216': 'Objective Thinker',
    '2217': 'Objective Thinker',
    '2221': 'Retake self-assessment',
    '2222': 'Retake self-assessment',
    '2223': 'Retake self-assessment',
    '2224': 'Retake self-assessment',
    '2225': 'Objective Thinker',
    '2226': 'Objective Thinker',
    '2227': 'Objective Thinker',
    '2231': 'Retake self-assessment',
    '2232': 'Retake self-assessment',
    '2233': 'Retake self-assessment',
    '2234': 'Retake self-assessment',
    '2235': 'Objective Thinker',
    '2236': 'Objective Thinker',
    '2237': 'Objective Thinker',
    '2241': 'Retake self-assessment',
    '2242': 'Retake self-assessment',
    '2243': 'Retake self-assessment',
    '2244': 'Retake self-assessment',
    '2245': 'Objective Thinker',
    '2246': 'Objective Thinker',
    '2247': 'Objective Thinker',
    '2251': 'Specialist',
    '2252': 'Specialist',
    '2253': 'Specialist',
    '2254': 'Specialist',
    '2255': 'Perfectionist',
    '2256': 'Perfectionist',
    '2257': 'Perfectionist',
    '2261': 'Specialist',
    '2262': 'Specialist',
    '2263': 'Specialist',
    '2264': 'Specialist',
    '2265': 'Perfectionist',
    '2266': 'Perfectionist',
    '2267': 'Perfectionist',
    '2271': 'Specialist',
    '2272': 'Specialist',
    '2273': 'Specialist',
    '2274': 'Specialist',
    '2275': 'Perfectionist',
    '2276': 'Perfectionist',
    '2277': 'Perfectionist',
    '2411': 'Retake self-assessment',
    '2412': 'Retake self-assessment',
    '2413': 'Retake self-assessment',
    '2414': 'Retake self-assessment',
    '2415': 'Objective Thinker',
    '2416': 'Objective Thinker',
    '2417': 'Objective Thinker',
    '2421': 'Retake self-assessment',
    '2422': 'Retake self-assessment',
    '2423': 'Retake self-assessment',
    '2424': 'Retake self-assessment',
    '2425': 'Objective Thinker',
    '2426': 'Objective Thinker',
    '2427': 'Objective Thinker',
    '2431': 'Retake self-assessment',
    '2432': 'Retake self-assessment',
    '2433': 'Retake self-assessment',
    '2434': 'Retake self-assessment',
    '2435': 'Objective Thinker',
    '2436': 'Objective Thinker',
    '2437': 'Objective Thinker',
    '2441': 'Retake self-assessment',
    '2442': 'Retake self-assessment',
    '2443': 'Retake self-assessment',
    '2444': 'Retake self-assessment',
    '2445': 'Objective Thinker',
    '2446': 'Objective Thinker',
    '2447': 'Objective Thinker',
    '2451': 'Specialist',
    '2452': 'Specialist',
    '2453': 'Specialist',
    '2454': 'Specialist',
    '2455': 'Perfectionist',
    '2456': 'Perfectionist',
    '2457': 'Perfectionist',
    '2461': 'Specialist',
    '2462': 'Specialist',
    '2463': 'Specialist',
    '2464': 'Specialist',
    '2465': 'Perfectionist',
    '2466': 'Perfectionist',
    '2467': 'Perfectionist',
    '2471': 'Specialist',
    '2472': 'Specialist',
    '2473': 'Specialist',
    '2474': 'Specialist',
    '2475': 'Perfectionist',
    '2476': 'Perfectionist',
    '2477': 'Perfectionist',
    '2511': 'Promoter',
    '2512': 'Promoter',
    '2513': 'Promoter',
    '2514': 'Promoter',
    '2515': 'Appraiser',
    '2516': 'Appraiser',
    '2517': 'Appraiser',
    '2521': 'Promoter',
    '2522': 'Promoter',
    '2523': 'Promoter',
    '2524': 'Promoter',
    '2525': 'Appraiser',
    '2526': 'Appraiser',
    '2527': 'Appraiser',
    '2531': 'Promoter',
    '2532': 'Promoter',
    '2533': 'Promoter',
    '2534': 'Promoter',
    '2535': 'Appraiser',
    '2536': 'Appraiser',
    '2537': 'Appraiser',
    '2541': 'Promoter',
    '2542': 'Promoter',
    '2543': 'Promoter',
    '2544': 'Promoter',
    '2545': 'Practitioner',
    '2546': 'Practitioner',
    '2547': 'Practitioner',
    '2551': 'Counselor',
    '2552': 'Counselor',
    '2553': 'Counselor',
    '2554': 'Counselor',
    '2555': 'Practitioner',
    '2556': 'Practitioner',
    '2557': 'Practitioner',
    '2561': 'Agent',
    '2562': 'Agent',
    '2563': 'Agent',
    '2564': 'Agent',
    '2565': 'Practitioner',
    '2566': 'Practitioner',
    '2567': 'Practitioner',
    '2571': 'Agent',
    '2572': 'Agent',
    '2573': 'Agent',
    '2574': 'Agent',
    '2575': 'Practitioner',
    '2576': 'Practitioner',
    '2577': 'Practitioner',
    '2711': 'Promoter',
    '2712': 'Promoter',
    '2713': 'Promoter',
    '2714': 'Promoter',
    '2715': 'Appraiser',
    '2716': 'Appraiser',
    '2717': 'Appraiser',
    '2721': 'Promoter',
    '2722': 'Promoter',
    '2723': 'Promoter',
    '2724': 'Promoter',
    '2725': 'Appraiser',
    '2726': 'Appraiser',
    '2727': 'Appraiser',
    '2731': 'Promoter',
    '2732': 'Promoter',
    '2733': 'Promoter',
    '2734': 'Promoter',
    '2735': 'Appraiser',
    '2736': 'Appraiser',
    '2737': 'Appraiser',
    '2741': 'Promoter',
    '2742': 'Promoter',
    '2743': 'Promoter',
    '2744': 'Promoter',
    '2745': 'Practitioner',
    '2746': 'Practitioner',
    '2747': 'Practitioner',
    '2751': 'Counselor',
    '2752': 'Counselor',
    '2753': 'Counselor',
    '2754': 'Counselor',
    '2755': 'Practitioner',
    '2756': 'Practitioner',
    '2757': 'Practitioner',
    '2761': 'Counselor',
    '2762': 'Counselor',
    '2763': 'Counselor',
    '2764': 'Counselor',
    '2765': 'Practitioner',
    '2766': 'Practitioner',
    '2767': 'Practitioner',
    '2771': 'Counselor',
    '2772': 'Counselor',
    '2773': 'Counselor',
    '2774': 'Counselor',
    '2775': 'Practitioner',
    '2776': 'Practitioner',
    '2777': 'Practitioner',
    '3111': 'Retake self-assessment',
    '3112': 'Retake self-assessment',
    '3113': 'Retake self-assessment',
    '3114': 'Retake self-assessment',
    '3115': 'Objective Thinker',
    '3116': 'Objective Thinker',
    '3117': 'Objective Thinker',
    '3121': 'Retake self-assessment',
    '3122': 'Retake self-assessment',
    '3123': 'Retake self-assessment',
    '3124': 'Retake self-assessment',
    '3125': 'Objective Thinker',
    '3126': 'Objective Thinker',
    '3127': 'Objective Thinker',
    '3131': 'Retake self-assessment',
    '3132': 'Retake self-assessment',
    '3133': 'Retake self-assessment',
    '3134': 'Retake self-assessment',
    '3135': 'Objective Thinker',
    '3136': 'Objective Thinker',
    '3137': 'Objective Thinker',
    '3141': 'Retake self-assessment',
    '3142': 'Retake self-assessment',
    '3143': 'Retake self-assessment',
    '3144': 'Retake self-assessment',
    '3145': 'Objective Thinker',
    '3146': 'Objective Thinker',
    '3147': 'Objective Thinker',
    '3151': 'Specialist',
    '3152': 'Specialist',
    '3153': 'Specialist',
    '3154': 'Specialist',
    '3155': 'Perfectionist',
    '3156': 'Perfectionist',
    '3157': 'Perfectionist',
    '3161': 'Specialist',
    '3162': 'Specialist',
    '3163': 'Specialist',
    '3164': 'Specialist',
    '3165': 'Perfectionist',
    '3166': 'Perfectionist',
    '3167': 'Perfectionist',
    '3171': 'Specialist',
    '3172': 'Specialist',
    '3173': 'Specialist',
    '3174': 'Specialist',
    '3175': 'Perfectionist',
    '3176': 'Perfectionist',
    '3177': 'Perfectionist',
    '3311': 'Retake self-assessment',
    '3312': 'Retake self-assessment',
    '3313': 'Retake self-assessment',
    '3314': 'Retake self-assessment',
    '3315': 'Objective Thinker',
    '3316': 'Objective Thinker',
    '3317': 'Objective Thinker',
    '3321': 'Retake self-assessment',
    '3322': 'Retake self-assessment',
    '3323': 'Retake self-assessment',
    '3324': 'Retake self-assessment',
    '3325': 'Objective Thinker',
    '3326': 'Objective Thinker',
    '3327': 'Objective Thinker',
    '3331': 'Retake self-assessment',
    '3332': 'Retake self-assessment',
    '3333': 'Retake self-assessment',
    '3334': 'Retake self-assessment',
    '3335': 'Objective Thinker',
    '3336': 'Objective Thinker',
    '3337': 'Objective Thinker',
    '3341': 'Retake self-assessment',
    '3342': 'Retake self-assessment',
    '3343': 'Retake self-assessment',
    '3344': 'Retake self-assessment',
    '3345': 'Objective Thinker',
    '3346': 'Objective Thinker',
    '3347': 'Objective Thinker',
    '3351': 'Specialist',
    '3352': 'Specialist',
    '3353': 'Specialist',
    '3354': 'Specialist',
    '3355': 'Perfectionist',
    '3356': 'Perfectionist',
    '3357': 'Perfectionist',
    '3361': 'Specialist',
    '3362': 'Specialist',
    '3363': 'Specialist',
    '3364': 'Specialist',
    '3365': 'Perfectionist',
    '3366': 'Perfectionist',
    '3367': 'Perfectionist',
    '3371': 'Specialist',
    '3372': 'Specialist',
    '3373': 'Specialist',
    '3374': 'Specialist',
    '3375': 'Perfectionist',
    '3376': 'Perfectionist',
    '3377': 'Perfectionist',
    '3411': 'Retake self-assessment',
    '3412': 'Retake self-assessment',
    '3413': 'Retake self-assessment',
    '3414': 'Retake self-assessment',
    '3415': 'Objective Thinker',
    '3416': 'Objective Thinker',
    '3417': 'Objective Thinker',
    '3421': 'Retake self-assessment',
    '3422': 'Retake self-assessment',
    '3423': 'Retake self-assessment',
    '3424': 'Retake self-assessment',
    '3425': 'Objective Thinker',
    '3426': 'Objective Thinker',
    '3427': 'Objective Thinker',
    '3431': 'Retake self-assessment',
    '3432': 'Retake self-assessment',
    '3433': 'Retake self-assessment',
    '3434': 'Retake self-assessment',
    '3435': 'Objective Thinker',
    '3436': 'Objective Thinker',
    '3437': 'Objective Thinker',
    '3441': 'Retake self-assessment',
    '3442': 'Retake self-assessment',
    '3443': 'Retake self-assessment',
    '3444': 'Retake self-assessment',
    '3445': 'Objective Thinker',
    '3446': 'Objective Thinker',
    '3447': 'Objective Thinker',
    '3451': 'Specialist',
    '3452': 'Specialist',
    '3453': 'Specialist',
    '3454': 'Specialist',
    '3455': 'Perfectionist',
    '3456': 'Perfectionist',
    '3457': 'Perfectionist',
    '3461': 'Specialist',
    '3462': 'Specialist',
    '3463': 'Specialist',
    '3464': 'Specialist',
    '3465': 'Perfectionist',
    '3466': 'Perfectionist',
    '3467': 'Perfectionist',
    '3471': 'Specialist',
    '3472': 'Specialist',
    '3473': 'Specialist',
    '3474': 'Specialist',
    '3475': 'Perfectionist',
    '3476': 'Perfectionist',
    '3477': 'Perfectionist',
    '3611': 'Promoter',
    '3612': 'Promoter',
    '3613': 'Promoter',
    '3614': 'Promoter',
    '3615': 'Appraiser',
    '3616': 'Appraiser',
    '3617': 'Appraiser',
    '3621': 'Promoter',
    '3622': 'Promoter',
    '3623': 'Promoter',
    '3624': 'Promoter',
    '3625': 'Appraiser',
    '3626': 'Appraiser',
    '3627': 'Appraiser',
    '3631': 'Promoter',
    '3632': 'Promoter',
    '3633': 'Promoter',
    '3634': 'Promoter',
    '3635': 'Appraiser',
    '3636': 'Appraiser',
    '3637': 'Appraiser',
    '3641': 'Promoter',
    '3642': 'Promoter',
    '3643': 'Promoter',
    '3644': 'Promoter',
    '3645': 'Practitioner',
    '3646': 'Practitioner',
    '3647': 'Practitioner',
    '3651': 'Counselor',
    '3652': 'Counselor',
    '3653': 'Counselor',
    '3654': 'Counselor',
    '3655': 'Practitioner',
    '3656': 'Practitioner',
    '3657': 'Practitioner',
    '3661': 'Counselor',
    '3662': 'Counselor',
    '3663': 'Counselor',
    '3664': 'Counselor',
    '3665': 'Practitioner',
    '3666': 'Practitioner',
    '3667': 'Practitioner',
    '3671': 'Agent',
    '3672': 'Agent',
    '3673': 'Agent',
    '3674': 'Agent',
    '3675': 'Practitioner',
    '3676': 'Practitioner',
    '3677': 'Practitioner',
    '3711': 'Promoter',
    '3712': 'Promoter',
    '3713': 'Promoter',
    '3714': 'Promoter',
    '3715': 'Appraiser',
    '3716': 'Appraiser',
    '3717': 'Appraiser',
    '3721': 'Promoter',
    '3722': 'Promoter',
    '3723': 'Promoter',
    '3724': 'Promoter',
    '3725': 'Appraiser',
    '3726': 'Appraiser',
    '3727': 'Appraiser',
    '3731': 'Promoter',
    '3732': 'Promoter',
    '3733': 'Promoter',
    '3734': 'Promoter',
    '3735': 'Appraiser',
    '3736': 'Appraiser',
    '3737': 'Appraiser',
    '3741': 'Promoter',
    '3742': 'Promoter',
    '3743': 'Promoter',
    '3744': 'Promoter',
    '3745': 'Practitioner',
    '3746': 'Practitioner',
    '3747': 'Practitioner',
    '3751': 'Counselor',
    '3752': 'Counselor',
    '3753': 'Counselor',
    '3754': 'Counselor',
    '3755': 'Practitioner',
    '3756': 'Practitioner',
    '3757': 'Practitioner',
    '3761': 'Counselor',
    '3762': 'Counselor',
    '3763': 'Counselor',
    '3764': 'Counselor',
    '3765': 'Practitioner',
    '3766': 'Practitioner',
    '3767': 'Practitioner',
    '3771': 'Counselor',
    '3772': 'Counselor',
    '3773': 'Counselor',
    '3774': 'Counselor',
    '3775': 'Practitioner',
    '3776': 'Practitioner',
    '3777': 'Practitioner',
    '4211': 'Retake self-assessment',
    '4212': 'Retake self-assessment',
    '4213': 'Retake self-assessment',
    '4214': 'Retake self-assessment',
    '4215': 'Objective Thinker',
    '4216': 'Objective Thinker',
    '4217': 'Objective Thinker',
    '4221': 'Retake self-assessment',
    '4222': 'Retake self-assessment',
    '4223': 'Retake self-assessment',
    '4224': 'Retake self-assessment',
    '4225': 'Objective Thinker',
    '4226': 'Objective Thinker',
    '4227': 'Objective Thinker',
    '4231': 'Retake self-assessment',
    '4232': 'Retake self-assessment',
    '4233': 'Retake self-assessment',
    '4234': 'Retake self-assessment',
    '4235': 'Objective Thinker',
    '4236': 'Objective Thinker',
    '4237': 'Objective Thinker',
    '4241': 'Retake self-assessment',
    '4242': 'Retake self-assessment',
    '4243': 'Retake self-assessment',
    '4244': 'Retake self-assessment',
    '4245': 'Objective Thinker',
    '4246': 'Objective Thinker',
    '4247': 'Objective Thinker',
    '4251': 'Specialist',
    '4252': 'Specialist',
    '4253': 'Specialist',
    '4254': 'Specialist',
    '4255': 'Perfectionist',
    '4256': 'Perfectionist',
    '4257': 'Perfectionist',
    '4261': 'Specialist',
    '4262': 'Specialist',
    '4263': 'Specialist',
    '4264': 'Specialist',
    '4265': 'Perfectionist',
    '4266': 'Perfectionist',
    '4267': 'Perfectionist',
    '4271': 'Specialist',
    '4272': 'Specialist',
    '4273': 'Specialist',
    '4274': 'Specialist',
    '4275': 'Perfectionist',
    '4276': 'Perfectionist',
    '4277': 'Perfectionist',
    '4311': 'Retake self-assessment',
    '4312': 'Retake self-assessment',
    '4313': 'Retake self-assessment',
    '4314': 'Retake self-assessment',
    '4315': 'Objective Thinker',
    '4316': 'Objective Thinker',
    '4317': 'Objective Thinker',
    '4321': 'Retake self-assessment',
    '4322': 'Retake self-assessment',
    '4323': 'Retake self-assessment',
    '4324': 'Retake self-assessment',
    '4325': 'Objective Thinker',
    '4326': 'Objective Thinker',
    '4327': 'Objective Thinker',
    '4331': 'Retake self-assessment',
    '4332': 'Retake self-assessment',
    '4333': 'Retake self-assessment',
    '4334': 'Retake self-assessment',
    '4335': 'Objective Thinker',
    '4336': 'Objective Thinker',
    '4337': 'Objective Thinker',
    '4341': 'Retake self-assessment',
    '4342': 'Retake self-assessment',
    '4343': 'Retake self-assessment',
    '4344': 'Retake self-assessment',
    '4345': 'Objective Thinker',
    '4346': 'Objective Thinker',
    '4347': 'Objective Thinker',
    '4351': 'Specialist',
    '4352': 'Specialist',
    '4353': 'Specialist',
    '4354': 'Specialist',
    '4355': 'Perfectionist',
    '4356': 'Perfectionist',
    '4357': 'Perfectionist',
    '4361': 'Specialist',
    '4362': 'Specialist',
    '4363': 'Specialist',
    '4364': 'Specialist',
    '4365': 'Perfectionist',
    '4366': 'Perfectionist',
    '4367': 'Perfectionist',
    '4371': 'Specialist',
    '4372': 'Specialist',
    '4373': 'Specialist',
    '4374': 'Specialist',
    '4375': 'Perfectionist',
    '4376': 'Perfectionist',
    '4377': 'Perfectionist',
    '4511': 'Promoter',
    '4512': 'Promoter',
    '4513': 'Promoter',
    '4514': 'Promoter',
    '4515': 'Appraiser',
    '4516': 'Appraiser',
    '4517': 'Appraiser',
    '4521': 'Promoter',
    '4522': 'Promoter',
    '4523': 'Promoter',
    '4524': 'Promoter',
    '4525': 'Appraiser',
    '4526': 'Appraiser',
    '4527': 'Appraiser',
    '4531': 'Promoter',
    '4532': 'Promoter',
    '4533': 'Promoter',
    '4534': 'Promoter',
    '4535': 'Appraiser',
    '4536': 'Appraiser',
    '4537': 'Appraiser',
    '4541': 'Counselor',
    '4542': 'Counselor',
    '4543': 'Counselor',
    '4544': 'Retake self-assessment',
    '4545': 'Practitioner',
    '4546': 'Practitioner',
    '4547': 'Practitioner',
    '4551': 'Counselor',
    '4552': 'Counselor',
    '4553': 'Counselor',
    '4554': 'Counselor',
    '4555': 'Retake self-assessment',
    '4556': 'Practitioner',
    '4557': 'Practitioner',
    '4561': 'Agent',
    '4562': 'Agent',
    '4563': 'Agent',
    '4564': 'Agent',
    '4565': 'Practitioner',
    '4566': 'Practitioner',
    '4567': 'Practitioner',
    '4571': 'Agent',
    '4572': 'Agent',
    '4573': 'Agent',
    '4574': 'Agent',
    '4575': 'Practitioner',
    '4576': 'Practitioner',
    '4577': 'Practitioner',
    '4611': 'Promoter',
    '4612': 'Promoter',
    '4613': 'Promoter',
    '4614': 'Promoter',
    '4615': 'Appraiser',
    '4616': 'Appraiser',
    '4617': 'Appraiser',
    '4621': 'Promoter',
    '4622': 'Promoter',
    '4623': 'Promoter',
    '4624': 'Promoter',
    '4625': 'Appraiser',
    '4626': 'Appraiser',
    '4627': 'Appraiser',
    '4631': 'Promoter',
    '4632': 'Promoter',
    '4633': 'Promoter',
    '4634': 'Promoter',
    '4635': 'Appraiser',
    '4636': 'Appraiser',
    '4637': 'Appraiser',
    '4641': 'Promoter',
    '4642': 'Promoter',
    '4643': 'Promoter',
    '4644': 'Promoter',
    '4645': 'Appraiser',
    '4646': 'Appraiser',
    '4647': 'Appraiser',
    '4651': 'Counselor',
    '4652': 'Counselor',
    '4653': 'Counselor',
    '4654': 'Counselor',
    '4655': 'Practitioner',
    '4656': 'Practitioner',
    '4657': 'Practitioner',
    '4661': 'Counselor',
    '4662': 'Counselor',
    '4663': 'Counselor',
    '4664': 'Counselor',
    '4665': 'Practitioner',
    '4666': 'Practitioner',
    '4667': 'Practitioner',
    '4671': 'Agent',
    '4672': 'Agent',
    '4673': 'Agent',
    '4674': 'Agent',
    '4675': 'Practitioner',
    '4676': 'Practitioner',
    '4677': 'Practitioner',
    '5111': 'Developer',
    '5112': 'Developer',
    '5113': 'Developer',
    '5114': 'Developer',
    '5115': 'Creative',
    '5116': 'Creative',
    '5117': 'Creative',
    '5121': 'Developer',
    '5122': 'Developer',
    '5123': 'Developer',
    '5124': 'Developer',
    '5125': 'Creative',
    '5126': 'Creative',
    '5127': 'Creative',
    '5131': 'Developer',
    '5132': 'Developer',
    '5133': 'Developer',
    '5134': 'Developer',
    '5135': 'Creative',
    '5136': 'Creative',
    '5137': 'Creative',
    '5141': 'Developer',
    '5142': 'Developer',
    '5143': 'Developer',
    '5144': 'Developer',
    '5145': 'Creative',
    '5146': 'Creative',
    '5147': 'Creative',
    '5151': 'Achiever',
    '5152': 'Achiever',
    '5153': 'Achiever',
    '5154': 'Achiever',
    '5155': 'Investigator',
    '5156': 'Investigator',
    '5157': 'Investigator',
    '5161': 'Achiever',
    '5162': 'Achiever',
    '5163': 'Achiever',
    '5164': 'Achiever',
    '5165': 'Investigator',
    '5166': 'Investigator',
    '5167': 'Investigator',
    '5171': 'Achiever',
    '5172': 'Achiever',
    '5173': 'Achiever',
    '5174': 'Achiever',
    '5175': 'Investigator',
    '5176': 'Investigator',
    '5177': 'Investigator',
    '5211': 'Developer',
    '5212': 'Developer',
    '5213': 'Developer',
    '5214': 'Developer',
    '5215': 'Creative',
    '5216': 'Creative',
    '5217': 'Creative',
    '5221': 'Developer',
    '5222': 'Developer',
    '5223': 'Developer',
    '5224': 'Developer',
    '5225': 'Creative',
    '5226': 'Creative',
    '5227': 'Creative',
    '5231': 'Developer',
    '5232': 'Developer',
    '5233': 'Developer',
    '5234': 'Developer',
    '5235': 'Creative',
    '5236': 'Creative',
    '5237': 'Creative',
    '5241': 'Developer',
    '5242': 'Developer',
    '5243': 'Developer',
    '5244': 'Developer',
    '5245': 'Creative',
    '5246': 'Creative',
    '5247': 'Creative',
    '5251': 'Achiever',
    '5252': 'Achiever',
    '5253': 'Achiever',
    '5254': 'Achiever',
    '5255': 'Investigator',
    '5256': 'Investigator',
    '5257': 'Investigator',
    '5261': 'Achiever',
    '5262': 'Achiever',
    '5263': 'Achiever',
    '5264': 'Achiever',
    '5265': 'Investigator',
    '5266': 'Investigator',
    '5267': 'Investigator',
    '5271': 'Achiever',
    '5272': 'Achiever',
    '5273': 'Achiever',
    '5274': 'Achiever',
    '5275': 'Investigator',
    '5276': 'Investigator',
    '5277': 'Investigator',
    '5411': 'Result-Oriented',
    '5412': 'Result-Oriented',
    '5413': 'Result-Oriented',
    '5414': 'Result-Oriented',
    '5415': 'Creative',
    '5416': 'Creative',
    '5417': 'Creative',
    '5421': 'Result-Oriented',
    '5422': 'Result-Oriented',
    '5423': 'Result-Oriented',
    '5424': 'Result-Oriented',
    '5425': 'Creative',
    '5426': 'Creative',
    '5427': 'Creative',
    '5431': 'Result-Oriented',
    '5432': 'Result-Oriented',
    '5433': 'Result-Oriented',
    '5434': 'Result-Oriented',
    '5435': 'Creative',
    '5436': 'Creative',
    '5437': 'Creative',
    '5441': 'Result-Oriented',
    '5442': 'Result-Oriented',
    '5443': 'Result-Oriented',
    '5444': 'Retake self-assessment',
    '5445': 'Creative',
    '5446': 'Creative',
    '5447': 'Creative',
    '5451': 'Achiever',
    '5452': 'Achiever',
    '5453': 'Achiever',
    '5454': 'Achiever',
    '5455': 'Investigator',
    '5456': 'Investigator',
    '5457': 'Investigator',
    '5461': 'Achiever',
    '5462': 'Achiever',
    '5463': 'Achiever',
    '5464': 'Achiever',
    '5465': 'Investigator',
    '5466': 'Investigator',
    '5467': 'Investigator',
    '5471': 'Achiever',
    '5472': 'Achiever',
    '5473': 'Achiever',
    '5474': 'Achiever',
    '5475': 'Investigator',
    '5476': 'Investigator',
    '5477': 'Investigator',
    '5511': 'Inspirational',
    '5512': 'Inspirational',
    '5513': 'Inspirational',
    '5514': 'Inspirational',
    '5515': 'Appraiser',
    '5516': 'Appraiser',
    '5517': 'Appraiser',
    '5521': 'Inspirational',
    '5522': 'Inspirational',
    '5523': 'Inspirational',
    '5524': 'Inspirational',
    '5525': 'Appraiser',
    '5526': 'Appraiser',
    '5527': 'Appraiser',
    '5531': 'Inspirational',
    '5532': 'Inspirational',
    '5533': 'Inspirational',
    '5534': 'Inspirational',
    '5535': 'Appraiser',
    '5536': 'Appraiser',
    '5537': 'Appraiser',
    '5541': 'Inspirational',
    '5542': 'Inspirational',
    '5543': 'Inspirational',
    '5544': 'Retake self-assessment',
    '5545': 'Appraiser',
    '5546': 'Appraiser',
    '5547': 'Appraiser',
    '5551': 'Counselor',
    '5552': 'Counselor',
    '5553': 'Counselor',
    '5554': 'Retake self-assessment',
    '5555': 'Retake self-assessment',
    '5556': 'Retake self-assessment',
    '5557': 'Retake self-assessment',
    '5561': 'Agent',
    '5562': 'Agent',
    '5563': 'Agent',
    '5564': 'Agent',
    '5565': 'Retake self-assessment',
    '5566': 'Retake self-assessment',
    '5567': 'Retake self-assessment',
    '5571': 'Agent',
    '5572': 'Agent',
    '5573': 'Agent',
    '5574': 'Agent',
    '5575': 'Retake self-assessment',
    '5576': 'Retake self-assessment',
    '5577': 'Retake self-assessment',
    '5711': 'Persuader',
    '5712': 'Persuader',
    '5713': 'Persuader',
    '5714': 'Persuader',
    '5715': 'Appraiser',
    '5716': 'Appraiser',
    '5717': 'Appraiser',
    '5721': 'Persuader',
    '5722': 'Persuader',
    '5723': 'Persuader',
    '5724': 'Persuader',
    '5725': 'Appraiser',
    '5726': 'Appraiser',
    '5727': 'Appraiser',
    '5731': 'Persuader',
    '5732': 'Persuader',
    '5733': 'Persuader',
    '5734': 'Persuader',
    '5735': 'Appraiser',
    '5736': 'Appraiser',
    '5737': 'Appraiser',
    '5741': 'Persuader',
    '5742': 'Persuader',
    '5743': 'Persuader',
    '5744': 'Persuader',
    '5745': 'Appraiser',
    '5746': 'Appraiser',
    '5747': 'Appraiser',
    '5751': 'Persuader',
    '5752': 'Persuader',
    '5753': 'Persuader',
    '5754': 'Persuader',
    '5755': 'Retake self-assessment',
    '5756': 'Retake self-assessment',
    '5757': 'Retake self-assessment',
    '5761': 'Counselor',
    '5762': 'Counselor',
    '5763': 'Counselor',
    '5764': 'Counselor',
    '5765': 'Retake self-assessment',
    '5766': 'Retake self-assessment',
    '5767': 'Retake self-assessment',
    '5771': 'Counselor',
    '5772': 'Counselor',
    '5773': 'Counselor',
    '5774': 'Counselor',
    '5775': 'Retake self-assessment',
    '5776': 'Retake self-assessment',
    '5777': 'Retake self-assessment',
    '6111': 'Developer',
    '6112': 'Developer',
    '6113': 'Developer',
    '6114': 'Developer',
    '6115': 'Creative',
    '6116': 'Creative',
    '6117': 'Creative',
    '6121': 'Developer',
    '6122': 'Developer',
    '6123': 'Developer',
    '6124': 'Developer',
    '6125': 'Creative',
    '6126': 'Creative',
    '6127': 'Creative',
    '6131': 'Developer',
    '6132': 'Developer',
    '6133': 'Developer',
    '6134': 'Developer',
    '6135': 'Creative',
    '6136': 'Creative',
    '6137': 'Creative',
    '6141': 'Developer',
    '6142': 'Developer',
    '6143': 'Developer',
    '6144': 'Developer',
    '6145': 'Creative',
    '6146': 'Creative',
    '6147': 'Creative',
    '6151': 'Achiever',
    '6152': 'Achiever',
    '6153': 'Achiever',
    '6154': 'Achiever',
    '6155': 'Investigator',
    '6156': 'Investigator',
    '6157': 'Investigator',
    '6161': 'Achiever',
    '6162': 'Achiever',
    '6163': 'Achiever',
    '6164': 'Achiever',
    '6165': 'Investigator',
    '6166': 'Investigator',
    '6167': 'Investigator',
    '6171': 'Achiever',
    '6172': 'Achiever',
    '6173': 'Achiever',
    '6174': 'Achiever',
    '6175': 'Investigator',
    '6176': 'Investigator',
    '6177': 'Investigator',
    '6311': 'Developer',
    '6312': 'Developer',
    '6313': 'Developer',
    '6314': 'Developer',
    '6315': 'Creative',
    '6316': 'Creative',
    '6317': 'Creative',
    '6321': 'Developer',
    '6322': 'Developer',
    '6323': 'Developer',
    '6324': 'Developer',
    '6325': 'Creative',
    '6326': 'Creative',
    '6327': 'Creative',
    '6331': 'Developer',
    '6332': 'Developer',
    '6333': 'Developer',
    '6334': 'Developer',
    '6335': 'Creative',
    '6336': 'Creative',
    '6337': 'Creative',
    '6341': 'Developer',
    '6342': 'Developer',
    '6343': 'Developer',
    '6344': 'Developer',
    '6345': 'Creative',
    '6346': 'Creative',
    '6347': 'Creative',
    '6351': 'Achiever',
    '6352': 'Achiever',
    '6353': 'Achiever',
    '6354': 'Achiever',
    '6355': 'Investigator',
    '6356': 'Investigator',
    '6357': 'Investigator',
    '6361': 'Achiever',
    '6362': 'Achiever',
    '6363': 'Achiever',
    '6364': 'Achiever',
    '6365': 'Investigator',
    '6366': 'Investigator',
    '6367': 'Investigator',
    '6371': 'Achiever',
    '6372': 'Achiever',
    '6373': 'Achiever',
    '6374': 'Achiever',
    '6375': 'Investigator',
    '6376': 'Investigator',
    '6377': 'Investigator',
    '6411': 'Result-Oriented',
    '6412': 'Result-Oriented',
    '6413': 'Result-Oriented',
    '6414': 'Result-Oriented',
    '6415': 'Creative',
    '6416': 'Creative',
    '6417': 'Creative',
    '6421': 'Result-Oriented',
    '6422': 'Result-Oriented',
    '6423': 'Result-Oriented',
    '6424': 'Result-Oriented',
    '6425': 'Creative',
    '6426': 'Creative',
    '6427': 'Creative',
    '6431': 'Result-Oriented',
    '6432': 'Result-Oriented',
    '6433': 'Result-Oriented',
    '6434': 'Result-Oriented',
    '6435': 'Creative',
    '6436': 'Creative',
    '6437': 'Creative',
    '6441': 'Result-Oriented',
    '6442': 'Result-Oriented',
    '6443': 'Result-Oriented',
    '6444': 'Result-Oriented',
    '6445': 'Creative',
    '6446': 'Creative',
    '6447': 'Creative',
    '6451': 'Achiever',
    '6452': 'Achiever',
    '6453': 'Achiever',
    '6454': 'Achiever',
    '6455': 'Investigator',
    '6456': 'Investigator',
    '6457': 'Investigator',
    '6461': 'Achiever',
    '6462': 'Achiever',
    '6463': 'Achiever',
    '6464': 'Achiever',
    '6465': 'Investigator',
    '6466': 'Investigator',
    '6467': 'Investigator',
    '6471': 'Achiever',
    '6472': 'Achiever',
    '6473': 'Achiever',
    '6474': 'Achiever',
    '6475': 'Investigator',
    '6476': 'Investigator',
    '6477': 'Investigator',
    '6611': 'Inspirational',
    '6612': 'Inspirational',
    '6613': 'Inspirational',
    '6614': 'Inspirational',
    '6615': 'Appraiser',
    '6616': 'Appraiser',
    '6617': 'Appraiser',
    '6621': 'Inspirational',
    '6622': 'Inspirational',
    '6623': 'Inspirational',
    '6624': 'Inspirational',
    '6625': 'Appraiser',
    '6626': 'Appraiser',
    '6627': 'Appraiser',
    '6631': 'Inspirational',
    '6632': 'Inspirational',
    '6633': 'Inspirational',
    '6634': 'Inspirational',
    '6635': 'Appraiser',
    '6636': 'Appraiser',
    '6637': 'Appraiser',
    '6641': 'Inspirational',
    '6642': 'Inspirational',
    '6643': 'Inspirational',
    '6644': 'Inspirational',
    '6645': 'Appraiser',
    '6646': 'Appraiser',
    '6647': 'Appraiser',
    '6651': 'Inspirational',
    '6652': 'Inspirational',
    '6653': 'Inspirational',
    '6654': 'Inspirational',
    '6655': 'Retake self-assessment',
    '6656': 'Retake self-assessment',
    '6657': 'Retake self-assessment',
    '6661': 'Inspirational',
    '6662': 'Inspirational',
    '6663': 'Inspirational',
    '6664': 'Inspirational',
    '6665': 'Retake self-assessment',
    '6666': 'Retake self-assessment',
    '6667': 'Retake self-assessment',
    '6671': 'Inspirational',
    '6672': 'Inspirational',
    '6673': 'Inspirational',
    '6674': 'Inspirational',
    '6675': 'Retake self-assessment',
    '6676': 'Retake self-assessment',
    '6677': 'Retake self-assessment',
    '6711': 'Inspirational',
    '6712': 'Inspirational',
    '6713': 'Inspirational',
    '6714': 'Inspirational',
    '6715': 'Appraiser',
    '6716': 'Appraiser',
    '6717': 'Appraiser',
    '6721': 'Inspirational',
    '6722': 'Inspirational',
    '6723': 'Inspirational',
    '6724': 'Inspirational',
    '6725': 'Appraiser',
    '6726': 'Appraiser',
    '6727': 'Appraiser',
    '6731': 'Inspirational',
    '6732': 'Inspirational',
    '6733': 'Inspirational',
    '6734': 'Inspirational',
    '6735': 'Appraiser',
    '6736': 'Appraiser',
    '6737': 'Appraiser',
    '6741': 'Inspirational',
    '6742': 'Inspirational',
    '6743': 'Inspirational',
    '6744': 'Inspirational',
    '6745': 'Appraiser',
    '6746': 'Appraiser',
    '6747': 'Appraiser',
    '6751': 'Inspirational',
    '6752': 'Inspirational',
    '6753': 'Inspirational',
    '6754': 'Inspirational',
    '6755': 'Retake self-assessment',
    '6756': 'Retake self-assessment',
    '6757': 'Retake self-assessment',
    '6761': 'Inspirational',
    '6762': 'Inspirational',
    '6763': 'Inspirational',
    '6764': 'Inspirational',
    '6765': 'Retake self-assessment',
    '6766': 'Retake self-assessment',
    '6767': 'Retake self-assessment',
    '6771': 'Inspirational',
    '6772': 'Inspirational',
    '6773': 'Inspirational',
    '6774': 'Inspirational',
    '6775': 'Retake self-assessment',
    '6776': 'Retake self-assessment',
    '6777': 'Retake self-assessment',
    '7211': 'Developer',
    '7212': 'Developer',
    '7213': 'Developer',
    '7214': 'Developer',
    '7215': 'Creative',
    '7216': 'Creative',
    '7217': 'Creative',
    '7221': 'Developer',
    '7222': 'Developer',
    '7223': 'Developer',
    '7224': 'Developer',
    '7225': 'Creative',
    '7226': 'Creative',
    '7227': 'Creative',
    '7231': 'Developer',
    '7232': 'Developer',
    '7233': 'Developer',
    '7234': 'Developer',
    '7235': 'Creative',
    '7236': 'Creative',
    '7237': 'Creative',
    '7241': 'Developer',
    '7242': 'Developer',
    '7243': 'Developer',
    '7244': 'Developer',
    '7245': 'Creative',
    '7246': 'Creative',
    '7247': 'Creative',
    '7251': 'Achiever',
    '7252': 'Achiever',
    '7253': 'Achiever',
    '7254': 'Achiever',
    '7255': 'Investigator',
    '7256': 'Investigator',
    '7257': 'Investigator',
    '7261': 'Achiever',
    '7262': 'Achiever',
    '7263': 'Achiever',
    '7264': 'Achiever',
    '7265': 'Investigator',
    '7266': 'Investigator',
    '7267': 'Investigator',
    '7271': 'Achiever',
    '7272': 'Achiever',
    '7273': 'Achiever',
    '7274': 'Achiever',
    '7275': 'Investigator',
    '7276': 'Investigator',
    '7277': 'Investigator',
    '7311': 'Developer',
    '7312': 'Developer',
    '7313': 'Developer',
    '7314': 'Developer',
    '7315': 'Creative',
    '7316': 'Creative',
    '7317': 'Creative',
    '7321': 'Developer',
    '7322': 'Developer',
    '7323': 'Developer',
    '7324': 'Developer',
    '7325': 'Creative',
    '7326': 'Creative',
    '7327': 'Creative',
    '7331': 'Developer',
    '7332': 'Developer',
    '7333': 'Developer',
    '7334': 'Developer',
    '7335': 'Creative',
    '7336': 'Creative',
    '7337': 'Creative',
    '7341': 'Developer',
    '7342': 'Developer',
    '7343': 'Developer',
    '7344': 'Developer',
    '7345': 'Creative',
    '7346': 'Creative',
    '7347': 'Creative',
    '7351': 'Achiever',
    '7352': 'Achiever',
    '7353': 'Achiever',
    '7354': 'Achiever',
    '7355': 'Investigator',
    '7356': 'Investigator',
    '7357': 'Investigator',
    '7361': 'Achiever',
    '7362': 'Achiever',
    '7363': 'Achiever',
    '7364': 'Achiever',
    '7365': 'Investigator',
    '7366': 'Investigator',
    '7367': 'Investigator',
    '7371': 'Achiever',
    '7372': 'Achiever',
    '7373': 'Achiever',
    '7374': 'Achiever',
    '7375': 'Investigator',
    '7376': 'Investigator',
    '7377': 'Investigator',
    '7511': 'Result-Oriented',
    '7512': 'Result-Oriented',
    '7513': 'Result-Oriented',
    '7514': 'Result-Oriented',
    '7515': 'Creative',
    '7516': 'Creative',
    '7517': 'Creative',
    '7521': 'Result-Oriented',
    '7522': 'Result-Oriented',
    '7523': 'Result-Oriented',
    '7524': 'Result-Oriented',
    '7525': 'Creative',
    '7526': 'Creative',
    '7527': 'Creative',
    '7531': 'Result-Oriented',
    '7532': 'Result-Oriented',
    '7533': 'Result-Oriented',
    '7534': 'Result-Oriented',
    '7535': 'Creative',
    '7536': 'Creative',
    '7537': 'Creative',
    '7541': 'Result-Oriented',
    '7542': 'Result-Oriented',
    '7543': 'Result-Oriented',
    '7544': 'Result-Oriented',
    '7545': 'Creative',
    '7546': 'Creative',
    '7547': 'Creative',
    '7551': 'Result-Oriented',
    '7552': 'Result-Oriented',
    '7553': 'Result-Oriented',
    '7554': 'Result-Oriented',
    '7555': 'Retake self-assessment',
    '7556': 'Retake self-assessment',
    '7557': 'Retake self-assessment',
    '7561': 'Achiever',
    '7562': 'Achiever',
    '7563': 'Achiever',
    '7564': 'Achiever',
    '7565': 'Retake self-assessment',
    '7566': 'Retake self-assessment',
    '7567': 'Retake self-assessment',
    '7571': 'Achiever',
    '7572': 'Achiever',
    '7573': 'Achiever',
    '7574': 'Achiever',
    '7575': 'Retake self-assessment',
    '7576': 'Retake self-assessment',
    '7577': 'Retake self-assessment',
    '7611': 'Inspirational',
    '7612': 'Inspirational',
    '7613': 'Inspirational',
    '7614': 'Inspirational',
    '7615': 'Creative',
    '7616': 'Creative',
    '7617': 'Creative',
    '7621': 'Inspirational',
    '7622': 'Inspirational',
    '7623': 'Inspirational',
    '7624': 'Inspirational',
    '7625': 'Creative',
    '7626': 'Creative',
    '7627': 'Creative',
    '7631': 'Inspirational',
    '7632': 'Inspirational',
    '7633': 'Inspirational',
    '7634': 'Inspirational',
    '7635': 'Creative',
    '7636': 'Creative',
    '7637': 'Creative',
    '7641': 'Inspirational',
    '7642': 'Inspirational',
    '7643': 'Inspirational',
    '7644': 'Inspirational',
    '7645': 'Creative',
    '7646': 'Creative',
    '7647': 'Creative',
    '7651': 'Inspirational',
    '7652': 'Inspirational',
    '7653': 'Inspirational',
    '7654': 'Inspirational',
    '7655': 'Retake self-assessment',
    '7656': 'Retake self-assessment',
    '7657': 'Retake self-assessment',
    '7661': 'Inspirational',
    '7662': 'Inspirational',
    '7663': 'Inspirational',
    '7664': 'Inspirational',
    '7665': 'Retake self-assessment',
    '7666': 'Retake self-assessment',
    '7667': 'Retake self-assessment',
    '7671': 'Achiever',
    '7672': 'Achiever',
    '7673': 'Achiever',
    '7674': 'Achiever',
    '7675': 'Retake self-assessment',
    '7676': 'Retake self-assessment',
    '7677': 'Retake self-assessment',
    '1111': 'Retake self-assessment',
    '1112': 'Retake self-assessment',
    '1113': 'Retake self-assessment',
    '1114': 'Retake self-assessment',
    '1115': 'Objective Thinker',
    '1116': 'Objective Thinker',
    '1117': 'Objective Thinker',
    '1121': 'Retake self-assessment',
    '1122': 'Retake self-assessment',
    '1123': 'Retake self-assessment',
    '1124': 'Retake self-assessment',
    '1125': 'Objective Thinker',
    '1126': 'Objective Thinker',
    '1127': 'Objective Thinker',
    '1131': 'Retake self-assessment',
    '1132': 'Retake self-assessment',
    '1133': 'Retake self-assessment',
    '1134': 'Retake self-assessment',
    '1135': 'Objective Thinker',
    '1136': 'Objective Thinker',
    '1137': 'Objective Thinker',
    '1141': 'Retake self-assessment',
    '1142': 'Retake self-assessment',
    '1143': 'Retake self-assessment',
    '1144': 'Retake self-assessment',
    '1145': 'Objective Thinker',
    '1146': 'Objective Thinker',
    '1147': 'Objective Thinker',
    '1151': 'Specialist',
    '1152': 'Specialist',
    '1153': 'Specialist',
    '1154': 'Specialist',
    '1155': 'Perfectionist',
    '1156': 'Perfectionist',
    '1157': 'Perfectionist',
    '1161': 'Specialist',
    '1162': 'Specialist',
    '1163': 'Specialist',
    '1164': 'Specialist',
    '1165': 'Perfectionist',
    '1166': 'Perfectionist',
    '1167': 'Perfectionist',
    '1171': 'Specialist',
    '1172': 'Specialist',
    '1173': 'Specialist',
    '1174': 'Specialist',
    '1175': 'Perfectionist',
    '1176': 'Perfectionist',
    '1177': 'Perfectionist',
    '1411': 'Retake self-assessment',
    '1412': 'Retake self-assessment',
    '1413': 'Retake self-assessment',
    '1414': 'Retake self-assessment',
    '1415': 'Objective Thinker',
    '1416': 'Objective Thinker',
    '1417': 'Objective Thinker',
    '1421': 'Retake self-assessment',
    '1422': 'Retake self-assessment',
    '1423': 'Retake self-assessment',
    '1424': 'Retake self-assessment',
    '1425': 'Objective Thinker',
    '1426': 'Objective Thinker',
    '1427': 'Objective Thinker',
    '1431': 'Retake self-assessment',
    '1432': 'Retake self-assessment',
    '1433': 'Retake self-assessment',
    '1434': 'Retake self-assessment',
    '1435': 'Objective Thinker',
    '1436': 'Objective Thinker',
    '1437': 'Objective Thinker',
    '1441': 'Retake self-assessment',
    '1442': 'Retake self-assessment',
    '1443': 'Retake self-assessment',
    '1444': 'Retake self-assessment',
    '1445': 'Objective Thinker',
    '1446': 'Objective Thinker',
    '1447': 'Objective Thinker',
    '1451': 'Specialist',
    '1452': 'Specialist',
    '1453': 'Specialist',
    '1454': 'Specialist',
    '1455': 'Perfectionist',
    '1456': 'Perfectionist',
    '1457': 'Perfectionist',
    '1461': 'Specialist',
    '1462': 'Specialist',
    '1463': 'Specialist',
    '1464': 'Specialist',
    '1465': 'Perfectionist',
    '1466': 'Perfectionist',
    '1467': 'Perfectionist',
    '1471': 'Specialist',
    '1472': 'Specialist',
    '1473': 'Specialist',
    '1474': 'Specialist',
    '1475': 'Perfectionist',
    '1476': 'Perfectionist',
    '1477': 'Perfectionist',
    '1711': 'Promoter',
    '1712': 'Promoter',
    '1713': 'Promoter',
    '1714': 'Promoter',
    '1715': 'Appraiser',
    '1716': 'Appraiser',
    '1717': 'Appraiser',
    '1721': 'Promoter',
    '1722': 'Promoter',
    '1723': 'Promoter',
    '1724': 'Promoter',
    '1725': 'Appraiser',
    '1726': 'Appraiser',
    '1727': 'Appraiser',
    '1731': 'Promoter',
    '1732': 'Promoter',
    '1733': 'Promoter',
    '1734': 'Promoter',
    '1735': 'Appraiser',
    '1736': 'Appraiser',
    '1737': 'Appraiser',
    '1741': 'Promoter',
    '1742': 'Promoter',
    '1743': 'Promoter',
    '1744': 'Promoter',
    '1745': 'Practitioner',
    '1746': 'Practitioner',
    '1747': 'Practitioner',
    '1751': 'Counselor',
    '1752': 'Counselor',
    '1753': 'Counselor',
    '1754': 'Counselor',
    '1755': 'Practitioner',
    '1756': 'Practitioner',
    '1757': 'Practitioner',
    '1761': 'Counselor',
    '1762': 'Counselor',
    '1763': 'Counselor',
    '1764': 'Counselor',
    '1765': 'Practitioner',
    '1766': 'Practitioner',
    '1767': 'Practitioner',
    '1771': 'Counselor',
    '1772': 'Counselor',
    '1773': 'Counselor',
    '1774': 'Counselor',
    '1775': 'Practitioner',
    '1776': 'Practitioner',
    '1777': 'Practitioner',
    '2311': 'Retake self-assessment',
    '2312': 'Retake self-assessment',
    '2313': 'Retake self-assessment',
    '2314': 'Retake self-assessment',
    '2315': 'Objective Thinker',
    '2316': 'Objective Thinker',
    '2317': 'Objective Thinker',
    '2321': 'Retake self-assessment',
    '2322': 'Retake self-assessment',
    '2323': 'Retake self-assessment',
    '2324': 'Retake self-assessment',
    '2325': 'Objective Thinker',
    '2326': 'Objective Thinker',
    '2327': 'Objective Thinker',
    '2331': 'Retake self-assessment',
    '2332': 'Retake self-assessment',
    '2333': 'Retake self-assessment',
    '2334': 'Retake self-assessment',
    '2335': 'Objective Thinker',
    '2336': 'Objective Thinker',
    '2337': 'Objective Thinker',
    '2341': 'Retake self-assessment',
    '2342': 'Retake self-assessment',
    '2343': 'Retake self-assessment',
    '2344': 'Retake self-assessment',
    '2345': 'Objective Thinker',
    '2346': 'Objective Thinker',
    '2347': 'Objective Thinker',
    '2351': 'Specialist',
    '2352': 'Specialist',
    '2353': 'Specialist',
    '2354': 'Specialist',
    '2355': 'Perfectionist',
    '2356': 'Perfectionist',
    '2357': 'Perfectionist',
    '2361': 'Specialist',
    '2362': 'Specialist',
    '2363': 'Specialist',
    '2364': 'Specialist',
    '2365': 'Perfectionist',
    '2366': 'Perfectionist',
    '2367': 'Perfectionist',
    '2371': 'Specialist',
    '2372': 'Specialist',
    '2373': 'Specialist',
    '2374': 'Specialist',
    '2375': 'Perfectionist',
    '2376': 'Perfectionist',
    '2377': 'Perfectionist',
    '2611': 'Promoter',
    '2612': 'Promoter',
    '2613': 'Promoter',
    '2614': 'Promoter',
    '2615': 'Appraiser',
    '2616': 'Appraiser',
    '2617': 'Appraiser',
    '2621': 'Promoter',
    '2622': 'Promoter',
    '2623': 'Promoter',
    '2624': 'Promoter',
    '2625': 'Appraiser',
    '2626': 'Appraiser',
    '2627': 'Appraiser',
    '2631': 'Promoter',
    '2632': 'Promoter',
    '2633': 'Promoter',
    '2634': 'Promoter',
    '2635': 'Appraiser',
    '2636': 'Appraiser',
    '2637': 'Appraiser',
    '2641': 'Promoter',
    '2642': 'Promoter',
    '2643': 'Promoter',
    '2644': 'Promoter',
    '2645': 'Practitioner',
    '2646': 'Practitioner',
    '2647': 'Practitioner',
    '2651': 'Counselor',
    '2652': 'Counselor',
    '2653': 'Counselor',
    '2654': 'Counselor',
    '2655': 'Practitioner',
    '2656': 'Practitioner',
    '2657': 'Practitioner',
    '2661': 'Counselor',
    '2662': 'Counselor',
    '2663': 'Counselor',
    '2664': 'Counselor',
    '2665': 'Practitioner',
    '2666': 'Practitioner',
    '2667': 'Practitioner',
    '2671': 'Agent',
    '2672': 'Agent',
    '2673': 'Agent',
    '2674': 'Agent',
    '2675': 'Practitioner',
    '2676': 'Practitioner',
    '2677': 'Practitioner',
    '3211': 'Retake self-assessment',
    '3212': 'Retake self-assessment',
    '3213': 'Retake self-assessment',
    '3214': 'Retake self-assessment',
    '3215': 'Objective Thinker',
    '3216': 'Objective Thinker',
    '3217': 'Objective Thinker',
    '3221': 'Retake self-assessment',
    '3222': 'Retake self-assessment',
    '3223': 'Retake self-assessment',
    '3224': 'Retake self-assessment',
    '3225': 'Objective Thinker',
    '3226': 'Objective Thinker',
    '3227': 'Objective Thinker',
    '3231': 'Retake self-assessment',
    '3232': 'Retake self-assessment',
    '3233': 'Retake self-assessment',
    '3234': 'Retake self-assessment',
    '3235': 'Objective Thinker',
    '3236': 'Objective Thinker',
    '3237': 'Objective Thinker',
    '3241': 'Retake self-assessment',
    '3242': 'Retake self-assessment',
    '3243': 'Retake self-assessment',
    '3244': 'Retake self-assessment',
    '3245': 'Objective Thinker',
    '3246': 'Objective Thinker',
    '3247': 'Objective Thinker',
    '3251': 'Specialist',
    '3252': 'Specialist',
    '3253': 'Specialist',
    '3254': 'Specialist',
    '3255': 'Perfectionist',
    '3256': 'Perfectionist',
    '3257': 'Perfectionist',
    '3261': 'Specialist',
    '3262': 'Specialist',
    '3263': 'Specialist',
    '3264': 'Specialist',
    '3265': 'Perfectionist',
    '3266': 'Perfectionist',
    '3267': 'Perfectionist',
    '3271': 'Specialist',
    '3272': 'Specialist',
    '3273': 'Specialist',
    '3274': 'Specialist',
    '3275': 'Perfectionist',
    '3276': 'Perfectionist',
    '3277': 'Perfectionist',
    '3511': 'Promoter',
    '3512': 'Promoter',
    '3513': 'Promoter',
    '3514': 'Promoter',
    '3515': 'Appraiser',
    '3516': 'Appraiser',
    '3517': 'Appraiser',
    '3521': 'Promoter',
    '3522': 'Promoter',
    '3523': 'Promoter',
    '3524': 'Promoter',
    '3525': 'Appraiser',
    '3526': 'Appraiser',
    '3527': 'Appraiser',
    '3531': 'Promoter',
    '3532': 'Promoter',
    '3533': 'Promoter',
    '3534': 'Promoter',
    '3535': 'Appraiser',
    '3536': 'Appraiser',
    '3537': 'Appraiser',
    '3541': 'Promoter',
    '3542': 'Promoter',
    '3543': 'Promoter',
    '3544': 'Promoter',
    '3545': 'Practitioner',
    '3546': 'Practitioner',
    '3547': 'Practitioner',
    '3551': 'Counselor',
    '3552': 'Counselor',
    '3553': 'Counselor',
    '3554': 'Counselor',
    '3555': 'Practitioner',
    '3556': 'Practitioner',
    '3557': 'Practitioner',
    '3561': 'Agent',
    '3562': 'Agent',
    '3563': 'Agent',
    '3564': 'Agent',
    '3565': 'Practitioner',
    '3566': 'Practitioner',
    '3567': 'Practitioner',
    '3571': 'Agent',
    '3572': 'Agent',
    '3573': 'Agent',
    '3574': 'Agent',
    '3575': 'Practitioner',
    '3576': 'Practitioner',
    '3577': 'Practitioner',
    '4111': 'Retake self-assessment',
    '4112': 'Retake self-assessment',
    '4113': 'Retake self-assessment',
    '4114': 'Retake self-assessment',
    '4115': 'Objective Thinker',
    '4116': 'Objective Thinker',
    '4117': 'Objective Thinker',
    '4121': 'Retake self-assessment',
    '4122': 'Retake self-assessment',
    '4123': 'Retake self-assessment',
    '4124': 'Retake self-assessment',
    '4125': 'Objective Thinker',
    '4126': 'Objective Thinker',
    '4127': 'Objective Thinker',
    '4131': 'Retake self-assessment',
    '4132': 'Retake self-assessment',
    '4133': 'Retake self-assessment',
    '4134': 'Retake self-assessment',
    '4135': 'Objective Thinker',
    '4136': 'Objective Thinker',
    '4137': 'Objective Thinker',
    '4141': 'Retake self-assessment',
    '4142': 'Retake self-assessment',
    '4143': 'Retake self-assessment',
    '4144': 'Retake self-assessment',
    '4145': 'Objective Thinker',
    '4146': 'Objective Thinker',
    '4147': 'Objective Thinker',
    '4151': 'Specialist',
    '4152': 'Specialist',
    '4153': 'Specialist',
    '4154': 'Specialist',
    '4155': 'Perfectionist',
    '4156': 'Perfectionist',
    '4157': 'Perfectionist',
    '4161': 'Specialist',
    '4162': 'Specialist',
    '4163': 'Specialist',
    '4164': 'Specialist',
    '4165': 'Perfectionist',
    '4166': 'Perfectionist',
    '4167': 'Perfectionist',
    '4171': 'Specialist',
    '4172': 'Specialist',
    '4173': 'Specialist',
    '4174': 'Specialist',
    '4175': 'Perfectionist',
    '4176': 'Perfectionist',
    '4177': 'Perfectionist',
    '4411': 'Retake self-assessment',
    '4412': 'Retake self-assessment',
    '4413': 'Retake self-assessment',
    '4414': 'Retake self-assessment',
    '4415': 'Objective Thinker',
    '4416': 'Objective Thinker',
    '4417': 'Objective Thinker',
    '4421': 'Retake self-assessment',
    '4422': 'Retake self-assessment',
    '4423': 'Retake self-assessment',
    '4424': 'Retake self-assessment',
    '4425': 'Objective Thinker',
    '4426': 'Objective Thinker',
    '4427': 'Objective Thinker',
    '4431': 'Retake self-assessment',
    '4432': 'Retake self-assessment',
    '4433': 'Retake self-assessment',
    '4434': 'Retake self-assessment',
    '4435': 'Objective Thinker',
    '4436': 'Objective Thinker',
    '4437': 'Objective Thinker',
    '4441': 'Retake self-assessment',
    '4442': 'Retake self-assessment',
    '4443': 'Retake self-assessment',
    '4444': 'Retake self-assessment',
    '4445': 'Retake self-assessment',
    '4446': 'Objective Thinker',
    '4447': 'Objective Thinker',
    '4451': 'Specialist',
    '4452': 'Specialist',
    '4453': 'Specialist',
    '4454': 'Retake self-assessment',
    '4455': 'Retake self-assessment',
    '4456': 'Perfectionist',
    '4457': 'Perfectionist',
    '4461': 'Specialist',
    '4462': 'Specialist',
    '4463': 'Specialist',
    '4464': 'Specialist',
    '4465': 'Perfectionist',
    '4466': 'Perfectionist',
    '4467': 'Perfectionist',
    '4471': 'Specialist',
    '4472': 'Specialist',
    '4473': 'Specialist',
    '4474': 'Specialist',
    '4475': 'Perfectionist',
    '4476': 'Perfectionist',
    '4477': 'Perfectionist',
    '4711': 'Promoter',
    '4712': 'Promoter',
    '4713': 'Promoter',
    '4714': 'Promoter',
    '4715': 'Appraiser',
    '4716': 'Appraiser',
    '4717': 'Appraiser',
    '4721': 'Promoter',
    '4722': 'Promoter',
    '4723': 'Promoter',
    '4724': 'Promoter',
    '4725': 'Appraiser',
    '4726': 'Appraiser',
    '4727': 'Appraiser',
    '4731': 'Promoter',
    '4732': 'Promoter',
    '4733': 'Promoter',
    '4734': 'Promoter',
    '4735': 'Appraiser',
    '4736': 'Appraiser',
    '4737': 'Appraiser',
    '4741': 'Promoter',
    '4742': 'Promoter',
    '4743': 'Promoter',
    '4744': 'Promoter',
    '4745': 'Appraiser',
    '4746': 'Appraiser',
    '4747': 'Appraiser',
    '4751': 'Counselor',
    '4752': 'Counselor',
    '4753': 'Counselor',
    '4754': 'Counselor',
    '4755': 'Practitioner',
    '4756': 'Practitioner',
    '4757': 'Practitioner',
    '4761': 'Counselor',
    '4762': 'Counselor',
    '4763': 'Counselor',
    '4764': 'Counselor',
    '4765': 'Practitioner',
    '4766': 'Practitioner',
    '4767': 'Practitioner',
    '4771': 'Counselor',
    '4772': 'Counselor',
    '4773': 'Counselor',
    '4774': 'Counselor',
    '4775': 'Practitioner',
    '4776': 'Practitioner',
    '4777': 'Practitioner',
    '5311': 'Developer',
    '5312': 'Developer',
    '5313': 'Developer',
    '5314': 'Developer',
    '5315': 'Creative',
    '5316': 'Creative',
    '5317': 'Creative',
    '5321': 'Developer',
    '5322': 'Developer',
    '5323': 'Developer',
    '5324': 'Developer',
    '5325': 'Creative',
    '5326': 'Creative',
    '5327': 'Creative',
    '5331': 'Developer',
    '5332': 'Developer',
    '5333': 'Developer',
    '5334': 'Developer',
    '5335': 'Creative',
    '5336': 'Creative',
    '5337': 'Creative',
    '5341': 'Developer',
    '5342': 'Developer',
    '5343': 'Developer',
    '5344': 'Developer',
    '5345': 'Creative',
    '5346': 'Creative',
    '5347': 'Creative',
    '5351': 'Achiever',
    '5352': 'Achiever',
    '5353': 'Achiever',
    '5354': 'Achiever',
    '5355': 'Investigator',
    '5356': 'Investigator',
    '5357': 'Investigator',
    '5361': 'Achiever',
    '5362': 'Achiever',
    '5363': 'Achiever',
    '5364': 'Achiever',
    '5365': 'Investigator',
    '5366': 'Investigator',
    '5367': 'Investigator',
    '5371': 'Achiever',
    '5372': 'Achiever',
    '5373': 'Achiever',
    '5374': 'Achiever',
    '5375': 'Investigator',
    '5376': 'Investigator',
    '5377': 'Investigator',
    '5611': 'Persuader',
    '5612': 'Persuader',
    '5613': 'Persuader',
    '5614': 'Persuader',
    '5615': 'Appraiser',
    '5616': 'Appraiser',
    '5617': 'Appraiser',
    '5621': 'Persuader',
    '5622': 'Persuader',
    '5623': 'Persuader',
    '5624': 'Persuader',
    '5625': 'Appraiser',
    '5626': 'Appraiser',
    '5627': 'Appraiser',
    '5631': 'Persuader',
    '5632': 'Persuader',
    '5633': 'Persuader',
    '5634': 'Persuader',
    '5635': 'Appraiser',
    '5636': 'Appraiser',
    '5637': 'Appraiser',
    '5641': 'Persuader',
    '5642': 'Persuader',
    '5643': 'Persuader',
    '5644': 'Persuader',
    '5645': 'Appraiser',
    '5646': 'Appraiser',
    '5647': 'Appraiser',
    '5651': 'Persuader',
    '5652': 'Persuader',
    '5653': 'Persuader',
    '5654': 'Persuader',
    '5655': 'Retake self-assessment',
    '5656': 'Retake self-assessment',
    '5657': 'Retake self-assessment',
    '5661': 'Counselor',
    '5662': 'Counselor',
    '5663': 'Counselor',
    '5664': 'Counselor',
    '5665': 'Retake self-assessment',
    '5666': 'Retake self-assessment',
    '5667': 'Retake self-assessment',
    '5671': 'Agent',
    '5672': 'Agent',
    '5673': 'Agent',
    '5674': 'Agent',
    '5675': 'Retake self-assessment',
    '5676': 'Retake self-assessment',
    '5677': 'Retake self-assessment',
    '6211': 'Developer',
    '6212': 'Developer',
    '6213': 'Developer',
    '6214': 'Developer',
    '6215': 'Creative',
    '6216': 'Creative',
    '6217': 'Creative',
    '6221': 'Developer',
    '6222': 'Developer',
    '6223': 'Developer',
    '6224': 'Developer',
    '6225': 'Creative',
    '6226': 'Creative',
    '6227': 'Creative',
    '6231': 'Developer',
    '6232': 'Developer',
    '6233': 'Developer',
    '6234': 'Developer',
    '6235': 'Creative',
    '6236': 'Creative',
    '6237': 'Creative',
    '6241': 'Developer',
    '6242': 'Developer',
    '6243': 'Developer',
    '6244': 'Developer',
    '6245': 'Creative',
    '6246': 'Creative',
    '6247': 'Creative',
    '6251': 'Achiever',
    '6252': 'Achiever',
    '6253': 'Achiever',
    '6254': 'Achiever',
    '6255': 'Investigator',
    '6256': 'Investigator',
    '6257': 'Investigator',
    '6261': 'Achiever',
    '6262': 'Achiever',
    '6263': 'Achiever',
    '6264': 'Achiever',
    '6265': 'Investigator',
    '6266': 'Investigator',
    '6267': 'Investigator',
    '6271': 'Achiever',
    '6272': 'Achiever',
    '6273': 'Achiever',
    '6274': 'Achiever',
    '6275': 'Investigator',
    '6276': 'Investigator',
    '6277': 'Investigator',
    '6511': 'Result-Oriented',
    '6512': 'Result-Oriented',
    '6513': 'Result-Oriented',
    '6514': 'Result-Oriented',
    '6515': 'Creative',
    '6516': 'Creative',
    '6517': 'Creative',
    '6521': 'Result-Oriented',
    '6522': 'Result-Oriented',
    '6523': 'Result-Oriented',
    '6524': 'Result-Oriented',
    '6525': 'Creative',
    '6526': 'Creative',
    '6527': 'Creative',
    '6531': 'Result-Oriented',
    '6532': 'Result-Oriented',
    '6533': 'Result-Oriented',
    '6534': 'Result-Oriented',
    '6535': 'Creative',
    '6536': 'Creative',
    '6537': 'Creative',
    '6541': 'Result-Oriented',
    '6542': 'Result-Oriented',
    '6543': 'Result-Oriented',
    '6544': 'Result-Oriented',
    '6545': 'Creative',
    '6546': 'Creative',
    '6547': 'Creative',
    '6551': 'Result-Oriented',
    '6552': 'Result-Oriented',
    '6553': 'Result-Oriented',
    '6554': 'Result-Oriented',
    '6555': 'Retake self-assessment',
    '6556': 'Retake self-assessment',
    '6557': 'Retake self-assessment',
    '6561': 'Achiever',
    '6562': 'Achiever',
    '6563': 'Achiever',
    '6564': 'Achiever',
    '6565': 'Retake self-assessment',
    '6566': 'Retake self-assessment',
    '6567': 'Retake self-assessment',
    '6571': 'Achiever',
    '6572': 'Achiever',
    '6573': 'Achiever',
    '6574': 'Achiever',
    '6575': 'Retake self-assessment',
    '6576': 'Retake self-assessment',
    '6577': 'Retake self-assessment',
    '7111': 'Developer',
    '7112': 'Developer',
    '7113': 'Developer',
    '7114': 'Developer',
    '7115': 'Creative',
    '7116': 'Creative',
    '7117': 'Creative',
    '7121': 'Developer',
    '7122': 'Developer',
    '7123': 'Developer',
    '7124': 'Developer',
    '7125': 'Creative',
    '7126': 'Creative',
    '7127': 'Creative',
    '7131': 'Developer',
    '7132': 'Developer',
    '7133': 'Developer',
    '7134': 'Developer',
    '7135': 'Creative',
    '7136': 'Creative',
    '7137': 'Creative',
    '7141': 'Developer',
    '7142': 'Developer',
    '7143': 'Developer',
    '7144': 'Developer',
    '7145': 'Creative',
    '7146': 'Creative',
    '7147': 'Creative',
    '7151': 'Achiever',
    '7152': 'Achiever',
    '7153': 'Achiever',
    '7154': 'Achiever',
    '7155': 'Investigator',
    '7156': 'Investigator',
    '7157': 'Investigator',
    '7161': 'Achiever',
    '7162': 'Achiever',
    '7163': 'Achiever',
    '7164': 'Achiever',
    '7165': 'Investigator',
    '7166': 'Investigator',
    '7167': 'Investigator',
    '7171': 'Achiever',
    '7172': 'Achiever',
    '7173': 'Achiever',
    '7174': 'Achiever',
    '7175': 'Investigator',
    '7176': 'Investigator',
    '7177': 'Investigator',
    '7411': 'Result-Oriented',
    '7412': 'Result-Oriented',
    '7413': 'Result-Oriented',
    '7414': 'Result-Oriented',
    '7415': 'Creative',
    '7416': 'Creative',
    '7417': 'Creative',
    '7421': 'Result-Oriented',
    '7422': 'Result-Oriented',
    '7423': 'Result-Oriented',
    '7424': 'Result-Oriented',
    '7425': 'Creative',
    '7426': 'Creative',
    '7427': 'Creative',
    '7431': 'Result-Oriented',
    '7432': 'Result-Oriented',
    '7433': 'Result-Oriented',
    '7434': 'Result-Oriented',
    '7435': 'Creative',
    '7436': 'Creative',
    '7437': 'Creative',
    '7441': 'Result-Oriented',
    '7442': 'Result-Oriented',
    '7443': 'Result-Oriented',
    '7444': 'Result-Oriented',
    '7445': 'Creative',
    '7446': 'Creative',
    '7447': 'Creative',
    '7451': 'Achiever',
    '7452': 'Achiever',
    '7453': 'Achiever',
    '7454': 'Achiever',
    '7455': 'Investigator',
    '7456': 'Investigator',
    '7457': 'Investigator',
    '7461': 'Achiever',
    '7462': 'Achiever',
    '7463': 'Achiever',
    '7464': 'Achiever',
    '7465': 'Investigator',
    '7466': 'Investigator',
    '7467': 'Investigator',
    '7471': 'Achiever',
    '7472': 'Achiever',
    '7473': 'Achiever',
    '7474': 'Achiever',
    '7475': 'Investigator',
    '7476': 'Investigator',
    '7477': 'Investigator',
    '7711': 'Inspirational',
    '7712': 'Inspirational',
    '7713': 'Inspirational',
    '7714': 'Inspirational',
    '7715': 'Appraiser',
    '7716': 'Appraiser',
    '7717': 'Appraiser',
    '7721': 'Inspirational',
    '7722': 'Inspirational',
    '7723': 'Inspirational',
    '7724': 'Inspirational',
    '7725': 'Appraiser',
    '7726': 'Appraiser',
    '7727': 'Appraiser',
    '7731': 'Inspirational',
    '7732': 'Inspirational',
    '7733': 'Inspirational',
    '7734': 'Inspirational',
    '7735': 'Appraiser',
    '7736': 'Appraiser',
    '7737': 'Appraiser',
    '7741': 'Inspirational',
    '7742': 'Inspirational',
    '7743': 'Inspirational',
    '7744': 'Inspirational',
    '7745': 'Appraiser',
    '7746': 'Appraiser',
    '7747': 'Appraiser',
    '7751': 'Inspirational',
    '7752': 'Inspirational',
    '7753': 'Inspirational',
    '7754': 'Inspirational',
    '7755': 'Retake self-assessment',
    '7756': 'Retake self-assessment',
    '7757': 'Retake self-assessment',
    '7761': 'Inspirational',
    '7762': 'Inspirational',
    '7763': 'Inspirational',
    '7764': 'Inspirational',
    '7765': 'Retake self-assessment',
    '7766': 'Retake self-assessment',
    '7767': 'Retake self-assessment',
    '7771': 'Inspirational',
    '7772': 'Inspirational',
    '7773': 'Inspirational',
    '7774': 'Inspirational',
    '7775': 'Retake self-assessment',
    '7776': 'Retake self-assessment',
    '7777': 'Retake self-assessment'
  },
  patterns: [
    {
      key: 'Achiever',
      name: 'Empreendedor',
      emotions: 'é trabalhador e diligente; demonstra frustração.',
      goal: 'realizações pessoais, às vezes em detrimento do objetivo do grupo',
      judges_others: 'capacidade de alcançar resultados concretos',
      influences_others: 'responsabilidade pelo próprio trabalho',
      value_organization: 'define e completa as principais áreas de resultados para si mesmo',
      overuses: 'confiança em si mesmo; absorção na tarefa',
      under_pressure: 'fica frustrado e impaciente; torna-se mais um "fazedor" e menos de um "delegado"',
      fears: 'outras pessoas com padrões de trabalho concorrentes ou inferiores, afetando os resultados',
      increase_effectiveness: 'redução de pensar "ou um ou outro"; clareza da prioridade da tarefa; consideração de abordagens opcionais; vontade de comprometer benefícios de curto prazo para longo prazo.',
      description: `A motivação dos Empreendedores é em grande parte interna e decorre de objetivos pessoais profundamente sentidos. Seu compromisso com seus próprios objetivos impede uma aceitação automática dos objetivos do grupo. Os Empreendedores precisam ver como eles podem combinar seus objetivos pessoais com os objetivos da organização. Ao manter o controle sobre a direção de suas vidas, os Empreendedores desenvolvem um forte senso de responsabilidade.

      Os empreendedores demonstram grande interesse em seu trabalho e uma busca intensa e contínua por realizações. Eles têm uma opinião elevada sobre seu trabalho e, sob pressão, podem hesitar em delegar tarefas. Em vez disso, eles próprios assumem o trabalho para garantir que as coisas sejam feitas da maneira certa. Quando delegam, têm tendência a retomar a tarefa se não está ocorrendo de acordo com as suas expectativas. Sua premissa é, "Se eu obter sucesso, eu quero o crédito, e se eu falhar, irei assumir a culpa."

      Um empreendedor deve comunicar mais com os outros para expandir o seu pensamento para além de "Eu tenho de fazer isso eu mesmo" ou "Eu quero todo o crédito." Eles podem precisar de ajuda para encontrar novas abordagens para alcançar os resultados desejados. Os empreendedores funcionam no pico de eficiência, e eles esperam reconhecimento igual à sua contribuição, salários elevados em organizações e liderança em outros grupos.`
    },
    {
      key: 'Agent',
      name: 'Agente',
      emotions: 'aceita afeto; rejeita agressão',
      goal: 'aceitação do grupo',
      judges_others: 'compromisso de tolerar e incluir todos',
      influences_others: 'empatia; amizade',
      value_organization: 'suporte, harmoniza, empatiza; concentra-se no serviço',
      overuses: 'gentileza.',
      under_pressure: 'torna-se persuasivo, usando informações ou amizades importantes, se necessário',
      fears: 'dissensão; conflito',
      increase_effectiveness: 'força na realização de quem eles são e o que eles podem fazer; firmeza e auto afirmação; capacidade de dizer "não" quando apropriado.',
      description: `Os agentes estão atentos tanto às relações humanas como aos aspectos da tarefa da sua situação de trabalho. Empáticos e apoiantes, são bons ouvintes e conhecidos pelo seu bom ouvido. Os agentes fazem as pessoas sentirem-se desejadas e necessárias, porque respondem às necessidades dos outros, as pessoas não receiam ser rejeitadas pelos agentes. Os agentes oferecem amizade e estão dispostos a realizar serviços para os outros.

      Os agentes têm um excelente potencial para organizar e completar tarefas de forma eficaz. Eles promovem naturalmente a harmonia e o trabalho em equipe, são particularmente bons em fazer pelos outros o que acham difícil de fazer por si próprios.

      Os agentes temem conflitos e dissensões. A sua abordagem de apoio pode permitir aos outros tolerar uma situação, em vez de os encorajar na resolução ativa de problemas. Além disso, a tendência do agente para adotar um perfil "baixo" - em vez de ter confrontos abertos com indivíduos agressivos - pode ser percebida como uma falta de "resistência". Embora estejam preocupados em integrar-se no grupo, os Agentes têm um grau de independência justo.`
    },
    {
      key: 'Appraiser',
      name: 'Avaliador',
      emotions: 'é levado a parecer bem',
      goal: '"vitória" com talento',
      judges_others: 'capacidade de iniciar atividades',
      influences_others: 'reconhecimento competitivo',
      value_organization: 'cumpre as metas com a equipe',
      overuses: 'autoridade; engenhosidade',
      under_pressure: 'torna-se inquieto, crítico, impaciente',
      fears: '"perda" ou "fracasso"; desaprovação dos outros',
      increase_effectiveness: 'acompanhamento individual ; empatia ao mostrar desaprovação; ritmo mais constante.',
      description: `Os avaliadores fazem com que as ideias criativas sirvam de objetivos práticos. Utilizam métodos diretos para alcançar resultados. Os avaliadores são competitivos, mas outras pessoas tendem a considerar os avaliadores como assertivos, em vez de agressivos, porque eles são atenciosos em relação aos outros. Em vez de dar ordens ou comandos, os Avaliadores envolvem as pessoas na tarefa através da persuasão. Eles conseguem a cooperação dos que os rodeiam, explicando a lógica das propostas de atividades.

      Avaliadores ajudam os outros a visualizar os passos que são necessários para alcançar resultados. Os avaliadores geralmente falam a partir de um plano de ação detalhado que desenvolveram para garantir uma progressão ordenada em direção aos resultados. Na sua ânsia de vencer, os avaliadores podem ficar impacientes quando os seus padrões não são mantidos ou quando é necessário um acompanhamento extenso.

      Os avaliadores são bons pensadores críticos. São verbais nas suas críticas, e as suas palavras ocasionalmente podem ser cáusticas. Os avaliadores têm um controle melhor da situação, se relaxarem e se apressarem. Um axioma útil para o conseguir é: "Ganhamos alguns e perdemos outros".`
    },
    {
      key: 'Counselor',
      name: 'Conselheiro',
      emotions: 'ser acessível; mostrando carinho e compreensão',
      goal: 'amizade; felicidade',
      judges_others: 'aceitação positiva dos outros; capacidade de procurar o bem nas pessoas',
      influences_others: 'relações pessoais; política de "porta aberta"',
      value_organization: 'permanecer estável e previsível; desenvolver uma gama ampla de amizades; ouvir os sentimentos dos outros',
      overuses: 'abordagem indireta; tolerância',
      under_pressure: 'torna-se excessivamente flexível e íntimo; é muito confiante sem se diferenciar das pessoas',
      fears: 'pressionar as pessoas; ser acusado de causar dano',
      increase_effectiveness: 'atenção aos prazos; iniciativa para completar a tarefa',
      description: `Os conselheiros são particularmente eficazes na solução dos problemas das pessoas. Eles impressionam os outros com a sua presença, empatia e compreensão. O seu otimismo facilita a busca do bem nos outros. Os conselheiros preferem lidar uns com os outros, construindo relacionamentos duradouros. Como um bom ouvinte com um ouvido disposto a problemas, um conselheiro oferece sugestões suavemente e abstém-se de impor as suas ideias aos outros.

      Os conselheiros tendem a ser excessivamente tolerantes e pacientes com não produtores. Sob pressão, eles podem ter dificuldade em enfrentar problemas de desempenho. Os conselheiros podem ser indiretos ao emitir ordens, fazer exigências, ou disciplinar outras pessoas. Ao adotar a atitude de que "as pessoas são importantes", os conselheiros podem dar menos ênfase na realização de tarefas. Às vezes, eles precisam de assistência para estabelecer e cumprir prazos.

      Os conselheiros muitas vezes tomam as críticas como uma afronta pessoal, mas respondem bem à atenção e aos elogios por tarefas concluídas. Quando em uma posição de responsabilidade, os conselheiros tendem a estar atentos à qualidade das condições de trabalho e a proporcionar um reconhecimento adequado aos membros do seu grupo.`
    },
    {
      key: 'Creative',
      name: 'Criativo',
      emotions: 'aceita agressão; restringe a expressão',
      goal: 'dominância; realizações únicas',
      judges_others: 'padrões pessoais; ideias progressivas para realizar tarefas',
      influences_others: 'capacidade de acompanhar o desenvolvimento de sistemas e abordagens inovadoras',
      value_organization: 'inicia ou projeta mudanças',
      overuses: 'franqueza; atitude crítica ou condescendente',
      under_pressure: 'aborrece-se com o trabalho de rotina; amua quando contido; age independentemente',
      fears: 'falta de influência; incapacidade de alcançar os seus padrões',
      increase_effectiveness: 'calor; comunicação diplomática; cooperação eficaz da equipe; reconhecimento de sanções existentes',
      description: `As pessoas com um Padrão Criativo exibem forças opostas no seu comportamento. O seu desejo de resultados tangíveis é contrabalançado por uma vontade igualmente forte de perfeição e a sua agressividade é temperada pela sensibilidade. Embora pensem e reajam rapidamente, elas são limitadas pelo desejo de explorar todas as soluções possíveis antes de tomarem uma decisão. 

      As pessoas criativas exibem visão quando se concentram em projetos, e provocam mudanças. Uma vez que os indivíduos com um Padrão Criativo têm um impulso para a perfeição e demonstram uma considerável capacidade de planejamento, as mudanças que fazem são provavelmente sólidas, mas o método pode precisar de atenção às relações interpessoais.

      As pessoas criativas querem liberdade para explorar, e querem ter autoridade para examinar e testar novamente os resultados. Podem tomar decisões diárias rapidamente, mas podem ser extremamente cautelosos ao tomarem decisões maiores: "Devo fazer essa promoção?" "Devo me mudar para outro local?" Em busca por resultados e perfeição, as pessoas criativas podem não se preocupar com o equilíbrio social. Em resultado disso, podem ser frias, distantes ou bruscas.`
    },
    {
      key: 'Developer',
      name: 'Desenvolvedor',
      emotions: 'preocupa-se em satisfazer as necessidades pessoais ',
      goal: 'novas oportunidades',
      judges_others: 'capacidade de satisfazer os padrões do Desenvolvedor',
      influences_others: 'busca de soluções para problemas; projeção do sentido de poder pessoal',
      value_organization: 'evita "passar a bola"; busca métodos novos ou inovadores de resolução de problemas',
      overuses: 'controle sobre pessoas e situações para alcançar os seus próprios resultados',
      under_pressure: 'trabalha sozinho para completar tarefas; é beligerante se o individualismo é ameaçado ou as oportunidades desafiadoras desaparecem',
      fears: 'tédio; perda de controle',
      increase_effectiveness: 'paciência, empatia; participação e colaboração com outros; acompanhamento e atenção ao controle de qualidade',
      description: `Os desenvolvedores tendem a ser indivíduos de vontade forte, buscando continuamente novos horizontes. Como auto-suficientes e pensadores independentes, eles preferem encontrar as suas próprias soluções. Relativamente livres da influência constrangedora do grupo, os Desenvolvedores são capazes de contornar as convenções e muitas vezes criar soluções inovadoras.
       
      Enquanto eles usam mais frequentemente um comportamento direto e vigoroso, os Desenvolvedores podem também manipular as pessoas e as situações de forma astuciosa. Quando obrigados a participar com outros em situações que limitam o seu individualismo, os desenvolvedores estão aptos a tornar-se beligerantes. São persistentes na busca dos resultados que desejam e farão o que for necessário para ultrapassar os obstáculos ao sucesso. Além disso, têm grandes expectativas em relação aos outros e podem ser críticos quando os seus padrões não são atingidos.
       
      Os desenvolvedores estão mais interessados em atingir seus próprios objetivos. Oportunidades de avanços e desafios são importantes para eles. Ao focar nos resultados, eles podem não ter empatia ou parecer indiferentes ao ignorar as preocupações dos outros .`
    },
    {
      key: 'Inspirational',
      name: 'Inspirador',
      emotions: 'aceita agressão; minimiza a necessidade de afeto',
      goal: 'controle de seu ambiente ou público',
      judges_others: 'projeção de força pessoal, caráter e poder social',
      influences_others: 'encanto, direção, intimidação; uso de recompensas',
      value_organization: 'atua como um " movedor de pessoas "; inicia, exige, elogios, disciplinas',
      Exageros: 'atitude de que "os fins justificam os meios"',
      under_pressure: 'torna-se manipulador, briguento ou beligerante',
      fears: 'comportamento fraco; perda de status social',
      increase_effectiveness: 'sensibilidade genuína; vontade de ajudar outros a terem sucesso em seu próprio desenvolvimento pessoal',
      description: `As pessoas com o Padrão Inspiracional tentam conscientemente modificar os pensamentos e ações dos outros, elas querem controlar o seu ambiente. São astutos em identificar e manipular os motivos existentes de um indivíduo a fim de orientar o comportamento dessa pessoa para um fim pré-determinado.
       
      As pessoas inspiradoras são claras quanto aos resultados que desejam, mas nem sempre os verbalizam imediatamente. Elas só introduzem os resultados que querem depois de terem preparado a outra pessoa, oferecendo amizade àqueles que desejam aceitação, autoridade e aqueles que procuram poder, e segurança e um ambiente previsível.

      As pessoas inspiradoras podem ser encantadoras nas suas interações. São persuasivas ao obter assistência para detalhes repetitivos e demorados. As pessoas experimentam frequentemente uma sensação de conflito ao sentirem-se atraídas por pessoas inspiradoras e ao mesmo tempo curiosamente distanciadas. Outras podem sentir-se "usadas" pelos poderes de manipulação das pessoas inspiradoras. Enquanto por vezes inspiram medo nos outros e se sobrepõem às suas decisões, às pessoas inspiradoras são geralmente bem recebidas pelos colegas de trabalho porque utilizam as suas consideráveis capacidades verbais para persuadir os outros sempre que possível. Às pessoas inspiradoras preferem claramente alcançar objetivos através da cooperação e persuasão, e não do domínio.`
    },
    {
      key: 'Investigator',
      name: 'Investigador',
      emotions: 'é desapaixonado; demonstra auto- disciplina',
      goal: 'poder por meio de funções formais e posições de autoridade',
      judges_others: 'uso de informações fatuais',
      influences_others: 'determinação, tenacidade',
      value_organization: 'oferece acompanhamento abrangente; trabalha com determinação em tarefas individualmente ou em um pequeno grupo',
      overuses: 'franqueza; suspeita de outros',
      under_pressure: 'tende a internalizar o conflito; guarda ressentimentos',
      fears: 'envolvimento com grande número de pessoas; responsabilidade de vender idéias abstratas',
      increase_effectiveness: 'flexibilidade; aceitação de outros; envolvimento pessoal com outros',
      description: `Objetivos e analíticos, os investigadores são "âncoras desapaixonadas da realidade". Em geral, não são constrangedores, seguem calmamente e firmemente um caminho independente em direção a um objetivo fixo. Os investigadores são bem sucedidos em muitas coisas, não devido à sua versatilidade, mas devido à sua determinação obstinada em seguir em frente. Procuram um propósito ou objetivo claro a partir do qual possam desenvolver um plano ordenado e organizar as suas ações. Uma vez iniciado um projeto, os Investigadores lutam tenazmente para atingir os seus objetivos. A intervenção às vezes é necessária para mudar a sua direcção. Como resultado, eles podem ser vistos como teimosos e opinantes.
      Os investigadores se saem bem com tarefas técnicas desafiantes, nas quais podem utilizar dados reais para interpretar a informação e tirar conclusões. Eles respondem mais à lógica do que à emoção. Ao vender ou comercializar uma ideia, são mais bem sucedidos com um produto concreto.
      Os investigadores não estão especialmente interessados em agradar as pessoas e preferem trabalhar sozinhos. Eles podem ser vistos como frios, contundentes e sem tato, porque valorizam a sua própria capacidade de pensamento. Os investigadores avaliam os outros pela forma como utilizam fatos e lógica. Para aumentar a sua eficácia nas interações pessoais, precisam desenvolver uma maior compreensão das outras pessoas, especialmente das emoções dos outros.`
    },
    {
      key: 'Objective Thinker',
      name: 'Pensador objetivo',
      emotions: 'rejeita agressão interpessoal',
      goal: 'correção',
      judges_others: 'capacidade de pensar logicamente',
      influences_others: 'uso de fatos, dados e argumentos lógicos',
      value_organization: 'define e esclarece; obtém, avalia e testa informações',
      overuses: 'análise',
      under_pressure: 'torna-se preocupante',
      fears: 'atos irracionais; ridicularização',
      increase_effectiveness: 'auto-divulgação; discussão pública de seus conhecimentos e opiniões',
      description: `Os pensadores objetivos tendem a ter capacidades de pensamento crítico altamente desenvolvidos. Eles enfatizam a importância dos fatos quando tiram conclusões e planejam ações, e procuram a correção e precisão em tudo o que fazem. Para gerir de forma eficaz as suas atividades de trabalho, os padrões objetivos combinam frequentemente informação intuitiva com os fatos que recolheram. Quando estão em dúvida sobre uma linha de ação, evitam o fracasso público preparando-se meticulosamente. Por exemplo, os padrões objetivos dominarão uma nova habilidade em privado antes de a utilizarem numa atividade de grupo.

      Os pensadores objetivos preferem trabalhar com pessoas que, como eles, estão interessados em manter um ambiente de trabalho pacífico. Considerados tímidos por alguns, podem ser reticentes em expressar os seus sentimentos. Sentem-se particularmente desconfortáveis com pessoas agressivas. Apesar de serem moderadamente educados, os Pensadores objetivos têm uma forte necessidade de controlar o seu ambiente. Tendem a exercer este controle indiretamente, exigindo que outros digam as regras e normas.

      Os Pensadores objetivos preocupam-se com a resposta "certa" e podem ter dificuldade em tomar decisões em situações ambíguas. Com a sua tendência para se preocuparem, podem ficar atolados na "paralisia da análise". Quando cometem um erro, os Pensadores Objetivos muitas vezes hesitam em reconhecê-lo. Em vez disso, mergulham numa busca de informação que sustenta a sua posição.`
    },
    {
      key: 'Perfectionist',
      name: 'Perfeccionista',
      emotions: 'demonstra competência; é contido e cauteloso',
      goal: 'estabilidade; realizações previsíveis',
      judges_others: 'normas precisas',
      influences_others: 'atenção aos detalhes; precisão',
      value_organization: 'é cuidadoso; mantém padrões; controla a qualidade',
      overuses: 'procedimentos e controles "à prova de falhas" ; dependência excessiva de pessoas, produtos e processos que funcionaram no passado',
      under_pressure: 'torna - se dedicado e diplomático',
      fears: 'antagonismo',
      increase_effectiveness: 'flexibilidade de funções ; independência e interdependência; crença na auto-estima',
      description: `Os perfeccionistas são pensadores e trabalhadores sistemáticos e precisos que seguem os procedimentos tanto na sua vida pessoal como profissional. Extremamente conscientes, são diligentes no trabalho que requer atenção aos detalhes e exatidão. Porque desejam condições estáveis e atividades previsíveis, os Perfeccionistas são mais confortáveis num ambiente de trabalho claramente definido. Desejam especificidades sobre expectativas de trabalho, requisitos de tempo e procedimentos de avaliação.

      Os perfeccionistas podem atolar-se nos detalhes do processo de tomada de decisão. Podem tomar decisões importantes, mas podem ser criticados pelo tempo que levam a recolher e analisar informação. Embora gostem de ouvir as opiniões dos seus gestores, os perfeccionistas correm riscos quando têm fatos que podem interpretar e utilizar para tirar conclusões.
      Os perfeccionistas avaliam-se a si próprios e aos outros através de normas precisas para alcançar resultados concretos, ao mesmo tempo que aderem a procedimentos operacionais normalizados. Esta atenção conscienciosa às normas e à qualidade é valiosa para a organização.
      Os perfeccionistas podem definir o seu valor excessivo pelo que fazem e não por quem são como pessoas. Como resultado, eles tendem a reagir a elogios pessoais pensando: "O que é que esta pessoa quer?” Ao aceitar elogios sinceros, os perfeccionistas podem aumentar a sua auto-confiança.`
    },
    {
      key: 'Persuader',
      name: 'Persuasivo',
      emotions: 'confia nos outros; está entusiasmado',
      goal: 'autoridade e prestígio; símbolos de status',
      judges_others: 'capacidade de verbalizar; flexibilidade',
      influences_others: 'maneira amigável e aberta; habilidade verbal',
      value_organization: 'vende e fecha; delega responsabilidade; está equilibrado e é confiante',
      overuses: 'entusiasmo; capacidade de venda; otimismo',
      under_pressure: 'torna - se indeciso e é facilmente persuadido; torna-se organizado para ter uma boa aparência',
      fears: 'ambiente fixo ; relacionamentos complexos',
      increase_effectiveness: 'tarefas desafiadoras; atenção ao serviço orientado à tarefa e aos principais detalhes; análise de dados objetivos',
      description: `Os persuasores trabalham com as pessoas, esforçando-se para serem amigáveis e, ao mesmo tempo, avançar com os seus próprios objetivos. Saídos e interessados nas pessoas, os persuasores têm a capacidade de ganhar o respeito e a confiança de vários tipos de pessoas. Os persuasores podem impressionar os seus pensamentos sobre os outros, atraindo pessoas para eles e mantendo-os como clientes ou amigos. Esta capacidade é particularmente útil quando os persuasores se vendem a si próprios ou às suas ideias para ganhar posições de autoridade.

      O ambiente mais favorável para os persuasores inclui trabalhar com pessoas, receber tarefas desafiadoras e experimentar uma variedade de atividades de trabalho que requerem mobilidade. Procuram tarefas de trabalho que lhes dêem a oportunidade de ter uma boa aparência. Como resultado da sua perspectiva positiva natural, os persuasores podem ser extremamente otimistas quanto aos resultados de um projeto e ao potencial dos outros. Os persuasores também tendem a subestimar a sua capacidade de alterar o comportamento dos outros.
       
      Embora os persuasores desejem liberdade da rotina e da regulamentação, precisam de receber dados analíticos numa base sistemática. Uma vez alertados para a importância das "pequenas coisas", os persuasores podem usar a informação para equilibrar o seu entusiasmo com uma avaliação realista da situação.`
    },
    {
      key: 'Practitioner',
      name: 'Praticante',
      emotions: 'quer acompanhar os outros em esforço e desempenho técnico',
      goal: 'crescimento pessoal',
      judges_others: 'autodisciplina; posição e promoções',
      influences_others: 'confiança em sua capacidade de dominar novas habilidades; desenvolvimento de procedimentos e ações "adequadas"',
      value_organization: 'é competente na resolução de problemas técnicos e de pessoas; demonstra proficiência e especialização',
      overuses: 'atenção excessiva aos objetivos pessoais; expectativas irrealistas de outros',
      under_pressure: 'torna - se contido; é sensível a críticas',
      fears: 'previsibilidade; nenhum reconhecimento como um "especialista"',
      increase_effectiveness: 'colaboração genuína para benefício comum; delegação de tarefas-chave a indivíduos apropriados',
      description: `Os praticantes valorizam a proficiência em áreas especializadas. Impulsionados pelo desejo de serem "bons em alguma coisa", monitoram cuidadosamente o seu próprio desempenho no trabalho. Embora o seu objetivo seja ser “o” especialistas em uma área, os Praticantes dão frequentemente a impressão de que sabem algo sobre tudo. Esta imagem é particularmente forte quando verbalizam os seus conhecimentos sobre uma variedade de assuntos.

      Como os Praticantes interagem uns com os outros, projetam um estilo descontraído, diplomático, e fácil. Esta atitude simpática pode mudar rapidamente na sua própria área de trabalho quando se tornam intensamente concentrados, de modo a satisfazerem elevados padrões de desempenho. Porque valorizam a autodisciplina, os Praticantes avaliam os outros com base na sua capacidade de se concentrarem no desempenho diário. Têm grandes expectativas em relação a si próprios e aos outros, e tendem a verbalizar a sua desilusão.

      Embora se concentrem naturalmente no desenvolvimento de uma abordagem organizada do trabalho e no aumento das suas próprias competências, os Praticantes também precisam de ajudar os outros a construir competências. Além disso, precisam aumentar a sua apreciação daqueles que contribuem para o esforço de trabalho, mesmo que não utilizem os métodos preferidos do praticante.`
    },
    {
      key: 'Promoter',
      name: 'Promotor',
      emotions: 'está disposto a aceitar os outros',
      goal: 'aprovação, popularidade',
      judges_others: 'habilidades verbais',
      influences_others: 'elogios, oportunidades, favores',
      value_organization: 'alivia a tensão; promove projetos e pessoas, incluindo ele próprio',
      Exageros: 'elogios, otimismo',
      under_pressure: 'torna - se descuidado e sentimental; é desorganizado',
      fears: 'perda de aceitação social e autoestima',
      increase_effectiveness: 'o controle de tempo; objetividade; senso de urgência; controle emocional ; seguimento de promessas, tarefas.',
      description: `Os promotores têm uma extensa rede de contatos, são geralmente reunidos e socialmente partidários, e desenvolvem facilmente amizades. Raramente antagonizam outros intencionalmente. Os promotores procuram ambientes sociais favoráveis onde possam desenvolver e manter os seus contatos. Verbalmente habilidosos, promovem as suas próprias ideias e criam entusiasmo pelos projetos dos outros. Com a sua vasta gama de contatos, os Promotores têm acesso às pessoas que os podem ajudar.

      Uma vez que os Promotores preferem participar e interagir com outros em atividades, podem estar menos interessados na realização de tarefas. Podem continuar a procurar qualquer situação que envolva conhecer pessoas e socializar, mesmo que o seu trabalho exija atenção a atividades mais solitárias. Prosperam em reuniões, comissões e conferências.

      Normalmente otimistas, os promotores tendem a subestimar a capacidade dos outros. Frequentemente saltam para conclusões favoráveis sem considerar todos os fatos. Os promotores aprendem a ser objetivos e enfatizam os resultados com treino e direção. A gestão do tempo pode apresentar desafios para os Promotores. Ao estabelecer um limite de tempo para a conversa e discussão, podem lembrar-se da urgência de "fechar" e cumprir a tarefa.`
    },
    {
      key: 'Result-Oriented',
      name: 'Orientado para resultados',
      emotions: 'verbaliza a força do ego ; exibe individualismo robusto',
      goal: 'domínio e independência',
      judges_others: 'capacidade de realizar a tarefa rapidamente',
      influences_others: 'força de caráter; persistência',
      value_organization: 'persistência; obstinação',
      overuses: 'impaciência; competição entre vencedores e perdedores',
      under_pressure: 'torna - se crítico e encontra falhas ; resiste a participar com uma equipe; pode ultrapassar limites',
      fears: 'outros tirarão vantagem deles; lentidão, especialmente em atividades de tarefa ; sendo uma tarefa simples',
      increase_effectiveness: 'verbalização de seu raciocínio; consideração de outros pontos de vista e ideias sobre objetivos e soluções de problemas ; preocupação genuína para os outros; paciência e humildade',
      description: `Pessoas orientadas para resultados demonstram autoconfiança, o que alguns podem interpretar como arrogância. Elas buscam ativamente oportunidades que testem e desenvolvam suas habilidades para alcançar resultados.

      Pessoas orientadas para resultados gostam de tarefas difíceis, situações competitivas , atribuições exclusivas e posições "importantes". Elas assumem responsabilidades com um ar de auto-importância e exibição de auto-satisfação , uma vez que elas tenham terminado.

       
      Pessoas orientadas para resultados tendem a evitar fatores restritivos, como controles diretos, detalhes demorados e trabalho de rotina. Por serem enérgicos e diretos, podem ter dificuldades com outras pessoas. Pessoas orientadas para resultados prezam sua independência e podem ficar inquietas quando envolvidas em atividades de grupo ou trabalho de comitê. Embora as pessoas orientadas para os resultados geralmente preferem trabalhar sozinhas, elas podem persuadir os outros a apoiarem seus esforços, especialmente ao concluir as atividades de rotina .

       
      Pessoas orientadas para os resultados pensam rapidamente e são impacientes e descobrem falhas com as que não o são. Elas avaliam os outros em sua capacidade de obter resultados. Pessoas orientadas para os resultados são determinadas e persistentes mesmo em face do antagonismo. Elas assumem o comando da situação quando necessário, estejam elas no comando ou não. Em sua busca intransigente por resultados, eles podem parecer rudes e indiferentes.`
    },
    {
      key: 'Specialist',
      name: 'Especialista',
      emotions: 'é calculadamente moderado; acomoda os outros',
      goal: 'manutenção do status quo; ambiente controlado',
      judges_others: 'padrões de amizade; competência',
      influences_others: 'desempenho consistente; acomodação de outros',
      value_organization: 'planos de curto prazo; é previsível, consistente; mantém estável ritmo',
      overuses: 'modéstia; baixo risco; resistência passiva à inovação',
      under_pressure: 'torna-se adaptável às autoridades e pensa com o grupo',
      fears: 'mudança, desorganização',
      increase_effectiveness: 'discussão pública de suas idéias; autoconfiança baseada em feedback; métodos de atalho',
      description: `Os especialistas "usam bem" com os outros. Com a sua moderação,
      postura e comportamento modesto, eles são capazes de trabalhar bem com uma série de estilos de comportamento. Especialistas são atenciosos, pacientes e sempre estão ali para ajudar aqueles que eles consideram como amigos. Eles constroem relacionamentos próximos com um
      grupo relativamente pequeno de associados no ambiente de trabalho.

      Seus esforços são direcionados para manter padrões familiares e previsíveis. Mais eficazes em áreas especializadas, os especialistas planejam o seu trabalho por canais direcionados e alcançam um desempenho notavelmente consistente. O apreço dos outros ajuda a manter esse nível de consistência.

      Os especialistas são lentos em se adaptar às mudanças. O condicionamento prévio lhes dá tempo para mudar seus procedimentos, mantendo um nível consistente de desempenho. Os especialistas também podem precisar de ajuda ao iniciar novos projetos e ao desenvolver métodos de atalhos para cumprir prazos. Os projetos terminados são frequentemente colocados de lado para revisões posteriores. Os especialistas devem considerar jogar fora arquivos antigos que tenham perdido sua utilidade.`
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/Disc/DiscSource.js